(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1146],{

/***/ 66015:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/localList",
      function () {
        return __webpack_require__(21340);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _QUERIES_prdt_goods_useGoodsDetail__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3081);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var TaggingGTM = function(props) {
    var ref;
    var goodsDetail = (ref = (0,_QUERIES_prdt_goods_useGoodsDetail__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(props.goodsCd).data) === null || ref === void 0 ? void 0 : ref.body;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!goodsDetail) return;
        try {
            dataLayer.push({
                event: "viewContent",
                ecommerce: {
                    detail: {
                        products: [
                            {
                                name: "".concat(goodsDetail.goodsNm),
                                id: "".concat(props.goodsCd),
                                category: "".concat(props.menu)
                            }, 
                        ]
                    }
                }
            });
        } catch (e) {
            ;
        }
    }, [
        goodsDetail
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (TaggingGTM);


/***/ }),

/***/ 58771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ EditorBox; }
/* harmony export */ });
/* unused harmony export BundleEditorBox */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93391);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin: ",
        ';\n	overflow: hidden;\n	p {\n		line-height: 1.6;\n		font-size: var(--default-size);\n		color: var(--default-color);\n		word-break: break-all;\n	}\n\n	table {\n		width: 100%;\n		border-top: 1px solid var(--emp-color);\n		border-spacing: 0;\n		border-collapse: collapse;\n		box-sizing: border-box;\n\n		thead > th {\n			border-right: 1px solid var(--line-color);\n		}\n		tr > th {\n			border-right: 1px solid var(--line-color);\n			border-bottom: 1px solid var(--line-color);\n		}\n\n		td {\n			padding: 20px;\n			border-right: 1px solid var(--line-color);\n			border-bottom: 1px solid var(--line-color);\n			background: #fff;\n			font-size: var(--default-size);\n			line-height: 1.6;\n			text-align: left;\n			&:last-child {\n				border-right: none;\n			}\n		}\n		th {\n			padding: 18px 0;\n			background-color: var(--disabled-color);\n			text-align: center;\n			font-size: var(--default-size);\n			color: var(--emp-color);\n			&:last-child {\n				border-right: none;\n			}\n		}\n		+ p {\n			margin-top: 8px;\n		}\n		+ table {\n			margin-top: 10px;\n		}\n	}\n\n	img {\n		max-width: 100%;\n		height: auto;\n		vertical-align: top;\n	}\n\n	strong {\n		font-family: "pr-font-medium";\n		font-weight: normal;\n	}\n\n	hr {\n		width: revert;\n		height: revert;\n		margin: revert;\n		border: revert;\n	}\n	@media print {\n		font-size: 24px;\n		h3 {\n			font-size: 18px;\n		}\n		p,\n		h5,\n		h6 {\n			font-size: 18px;\n			line-height: 1.6;\n		}\n		ul li,\n		ol li {\n			font-size: 18px;\n			line-height: 1.6;\n		}\n	}\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	padding: 15px 10px;\n	border: 1px solid var(--line-color);\n	background-color: var(--disabled-color);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var EditorBox = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-729f181b-0"
})(_templateObject(), function(props) {
    return props.margin ? props.margin : "";
});
var BundleEditorBox = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-729f181b-1"
})(_templateObject1());



/***/ }),

/***/ 64630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPath */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42277);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 공통 텍스트 배너조회 API
 *   `/global/goodsFlag`
 * parameter
 *      types: string (ex)"live,pang" 여러 타입 조회시 콤마(,)로 구분)
 * ```*/ var key = "useGlobalGoodsFlag";
var getPath = function() {
    return "/bff/global/goodsFlag";
};
/** ```
 * 공통 텍스트 배너조회 API
 *   `/global/goodsFlag`
 * parameter
 *      type: string (ex)"PKG,HOTEL,AIR,TOUR" 여러 타입 조회시 콤마(,)로 구분)
 * ```*/ var useGlobalGoodsFlag = function() {
    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "PKG", options = arguments.length > 1 ? arguments[1] : void 0;
    try {
        return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            queryKey: [
                key,
                type,
                getPath()
            ],
            queryFn: function() {
                return _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(getPath(), {
                    params: {
                        type: type
                    }
                }).then(function(r) {
                    return r.data;
                });
            },
            gcTime: Infinity,
            staleTime: Infinity,
            throwOnError: true
        }, options));
    } catch (error) {
        _FRAMEWORK_utils_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(error);
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (useGlobalGoodsFlag);



/***/ }),

/***/ 7682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sP": function() { return /* binding */ eventDetailAsync; }
/* harmony export */ });
/* unused harmony exports eventDetailSSR, getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _COMPONENTS_common_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23234);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87633);





var key = "useEventDetail";
/** ```
 * 행사 정보 조회
 *   `/prdt/api/event/{evCd}`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var getPath = function(evCd) {
    if (!evCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PRODUCT_API_BASEPATH */ .Z.ENV_PRODUCT_API_BASEPATH, "/api/event/").concat(evCd);
};
/** ```
 * 행사 정보 조회
 *   `/prdt/api/event/{evCd}`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var eventDetailAsync = function(evCd) {
    return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(getPath(evCd), {
        method: "GET"
    });
};
/** ```
 * 행사 정보 조회
 *   `/prdt/api/event/{evCd}`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var eventDetailSSR = function(evCd) {
    var removepath = publicRuntimeConfig.RUNTIME_ENV === "local" ? "" : publicRuntimeConfig.ENV_PRODUCT_API_BASEPATH;
    return useConfigureAxios(publicRuntimeConfig.ENV_PRODUCT_API_URL + getPath(evCd).replace(removepath, ""), {
        method: "GET"
    });
};
/** ```
 * 행사 정보 조회
 *   `/prdt/api/event/{evCd}`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var useEventDetail = function(evCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                url: getPath(evCd)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60,
        placeholderData: {
            body: _COMPONENTS_common_constants__WEBPACK_IMPORTED_MODULE_0__/* .EVENT_DETAIL */ .Ny
        }
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useEventDetail);



/***/ }),

/***/ 82834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kC": function() { return /* binding */ goodsCompareAsync; }
/* harmony export */ });
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20414);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87633);






/** ```
 * 상품 비교하기
 *   `/prdt/api/goods/compare
 * parameter
 *   `compareGoodsCd` 상품코드 ex) "ATP1127,ATP1164"
 * ```*/ var key = "useGoodsCompare";
var getPath = function(compareGoodsCd) {
    if (!compareGoodsCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PRODUCT_API_BASEPATH */ .Z.ENV_PRODUCT_API_BASEPATH, "/api/goods/compare?compareGoodsCd=").concat(compareGoodsCd);
};
/** ```
 * 상품 비교하기
 *   `/prdt/api/goods/compare
 * parameter
 *   `compareGoodsCd` 상품코드 ex) "ATP1127,ATP1164"
 * ```*/ var goodsCompareAsync = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(compareGoodsCd) {
        var result, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(getPath(compareGoodsCd), (_tmp.method = "GET", _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function goodsCompareAsync(compareGoodsCd) {
        return _ref.apply(this, arguments);
    };
}();
/** ```
 * 상품 비교하기
 *   `/prdt/api/goods/compare
 * parameter
 *   `compareGoodsCd` 상품코드 ex) "ATP1127,ATP1164"
 * ```*/ var useGoodsCompare = function(compareGoodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(compareGoodsCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(compareGoodsCd)
            }).then(function(r) {
                return r.data;
            });
        }
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useGoodsCompare);



/***/ }),

/***/ 85961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, goodsFilterSSR */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 상품 필터 정보
 *   `/prdt/api/filter/${dspSid}`
 * parameter
 * ```*/ var key = "useGoodsFilter";
var getPath = function(dspSid) {
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PRODUCT_API_BASEPATH */ .Z.ENV_PRODUCT_API_BASEPATH, "/api/goods/by-menu/").concat(dspSid, "/filter");
};
/** ```
 * 상품 필터 정보 SSR
 *   `/prdt/api/filter/${dspSid}`
 * parameter
 * ```*/ var goodsFilterSSR = function(dspSid) {
    var removepath = publicRuntimeConfig.RUNTIME_ENV === "local" ? "" : publicRuntimeConfig.ENV_PRODUCT_API_BASEPATH;
    return useConfigureAxios(publicRuntimeConfig.ENV_PRODUCT_API_URL + getPath(dspSid).replace(removepath, ""), {
        method: "GET"
    });
};
/** ```
 * 상품 필터 정보
 *   `/prdt/api/filter/${dspSid}`
 * parameter
 * ```*/ var useGoodsFilter = function(dspSid, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(dspSid)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(dspSid)
            }).then(function(r) {
                return r.data;
            });
        }
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useGoodsFilter);



/***/ }),

/***/ 21340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ localList_page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./hooks/common/useTagging.ts + 5 modules
var useTagging = __webpack_require__(40070);
// EXTERNAL MODULE: ./components/common/error/ErrorBoundary.tsx + 8 modules
var ErrorBoundary = __webpack_require__(17550);
// EXTERNAL MODULE: ./components/layout/breadcrumbs/desktop/index.tsx + 1 modules
var desktop = __webpack_require__(96646);
// EXTERNAL MODULE: ./components/layout/footer/Desktop/index.tsx + 1 modules
var Desktop = __webpack_require__(19145);
// EXTERNAL MODULE: ./components/layout/header/Desktop/index.tsx + 8 modules
var header_Desktop = __webpack_require__(2370);
// EXTERNAL MODULE: ./components/product/pages/localList/common/GTMTags.tsx
var GTMTags = __webpack_require__(21679);
// EXTERNAL MODULE: ./components/product/pages/localList/common/filterHook.tsx
var filterHook = __webpack_require__(87061);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./components/product/common/popup/common/constant.ts
var constant = __webpack_require__(6243);
// EXTERNAL MODULE: ./components/style/productlist/productlist.tsx
var productlist = __webpack_require__(29693);
// EXTERNAL MODULE: ./framework/ui/desktop/input/index.ts + 7 modules
var input = __webpack_require__(58127);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/product/pages/localList/desktop/filter/LocalHeadFilter.tsx









var LocalLvl4ListComponent = function(prop) {
    var lvl4ListData = prop.lvl4List.replaceAll("|", "").split("^");
    var lvl4List = [];
    for(var i = 0; i < lvl4ListData.length; i += 2){
        var code = lvl4ListData[i];
        var name = lvl4ListData[i + 1];
        lvl4List.push({
            code: code,
            name: name
        });
    }
    var ref = (0,filterHook/* default */.Z)(), getFilter = ref.getFilter, addFilter = ref.addFilter, removeFilter = ref.removeFilter;
    var handleClick = function(e) {
        var _target = e.target, value = _target.value, checked = _target.checked;
        var text = e.target.parentNode.textContent;
        checked && addFilter("dspSid", value, text);
        !checked && removeFilter("dspSid", value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* AreaGridList */.oR, {
        children: lvl4List && lvl4List.map(function(item, index) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Checkbox */.XZ, {
                        type: "checkbox",
                        id: "dspSid".concat(item.code),
                        value: item.code,
                        onChange: handleClick,
                        checked: ((ref = getFilter()) === null || ref === void 0 ? void 0 : ref.some(function(v) {
                            return v.value === item.code;
                        })) || false
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "dspSid".concat(item.code),
                        children: item.name
                    })
                ]
            }, index);
        })
    });
};
var LocalLvl4List = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "HeadFilter Lvl4List Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalLvl4ListComponent, (0,src_object_spread/* default */.Z)({}, props))
    });
};
var LocalHeadAreaComponent = function() {
    var ref = (0,filterHook/* default */.Z)(), getFilter = ref.getFilter, removeFilter = ref.removeFilter, setFilter = ref.setFilter;
    /* 선택 옵션리스트 (순서보정) */ var selectedList = (0,react.useMemo)(function() {
        var arr = [];
        var filters = getFilter();
        if (filters && filters.length > 0) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                var _loop = function() {
                    var key = _step.value;
                    if (key === "minPrice") {
                        var minPrice = filters.find(function(v) {
                            return v.key === "minPrice";
                        });
                        if (minPrice) arr = (0,_to_consumable_array/* default */.Z)(arr).concat([
                            {
                                key: "price",
                                text: minPrice.text
                            }
                        ]);
                    } else if (key === "maxPrice") {
                        var maxPrice = filters.find(function(v) {
                            return v.key === "maxPrice";
                        });
                        var priceObject = arr.find(function(v) {
                            return v.key === "price";
                        });
                        if (priceObject && maxPrice) priceObject.text += " ~ ".concat(maxPrice.text);
                    } else {
                        arr = (0,_to_consumable_array/* default */.Z)(arr).concat((0,_to_consumable_array/* default */.Z)(filters.filter(function(v) {
                            return v.key === key;
                        })));
                    }
                };
                for(var _iterator = constant/* L_SHOW_KEYS */.Dw[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        return arr;
    }, [
        getFilter()
    ]);
    var handleSelected = function(e) {
        /* X버튼 */ var _target = e.target, key = _target.id, value = _target.value;
        if (key === "price") {
            var setArr = getFilter().filter(function(item) {
                return ![
                    "minPrice",
                    "maxPrice"
                ].includes(item.key);
            }) || [];
            setFilter(setArr);
        } else if (key && value) {
            removeFilter(key, value);
        }
    };
    /* 전체삭제 */ var handleReset = (0,react.useCallback)(function() {
        var setArr = getFilter().filter(function(item) {
            return item.key === "sort";
        });
        setFilter(setArr);
    }, []);
    var scrollRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), isDragging = ref1[0], setIsDragging = ref1[1];
    var ref2 = (0,react.useState)(null), dragStartX = ref2[0], setDragStartX = ref2[1];
    var ref3 = (0,react.useState)(null), scrollStartX = ref3[0], setScrollStartX = ref3[1];
    // 버튼을 클릭 했을 때
    var handleMouseDown = function(e) {
        e.preventDefault();
        setIsDragging(true);
        setDragStartX(e.clientX);
        setScrollStartX(scrollRef.current.scrollLeft);
    };
    // 마우스가 움직일 때
    var handleMouseMove = function(e) {
        if (!isDragging) return;
        var dragDistance = e.clientX - dragStartX;
        scrollRef.current.scrollLeft = scrollStartX - dragDistance;
    };
    // 마우스 버튼을 놨을 때
    var handleMouseUp = function() {
        setIsDragging(false);
    };
    // 마우스가 컨테이너를 벗어났을 때
    var handleMouseLeave = function() {
        if (isDragging) {
            setIsDragging(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlist/* FilterTagContainer */.m2, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* FilterTitle */.Ux, {
                        children: "필터"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* FilterTagBox */.lD, {
                        ref: scrollRef,
                        onMouseDown: handleMouseDown,
                        onMouseMove: handleMouseMove,
                        onMouseUp: handleMouseUp,
                        onMouseLeave: handleMouseLeave,
                        children: selectedList.length > 0 && selectedList.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    item.text,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* FilterTagDeleteButton */.i4, {
                                        value: item.value,
                                        id: item.key,
                                        onClick: handleSelected,
                                        children: "닫기"
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* ResetButton */.JK, {
                type: "button",
                onClick: handleReset,
                children: "전체 삭제"
            })
        ]
    });
};
var LocalHeadArea = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "HeadFilter HeadArea Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalHeadAreaComponent, {})
    });
};


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./hooks/common/useOverlay.tsx + 1 modules
var useOverlay = __webpack_require__(91864);
// EXTERNAL MODULE: ./components/common/commonUtil.ts
var commonUtil = __webpack_require__(2576);
// EXTERNAL MODULE: ./components/common/modal/alert/Desktop.tsx
var alert_Desktop = __webpack_require__(64024);
// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
// EXTERNAL MODULE: ./framework/ui/desktop/filter/index.tsx
var desktop_filter = __webpack_require__(59758);
// EXTERNAL MODULE: ./framework/ui/desktop/layout/index.tsx + 2 modules
var layout = __webpack_require__(31267);
// EXTERNAL MODULE: ./framework/ui/desktop/select/index.ts
var desktop_select = __webpack_require__(64249);
// EXTERNAL MODULE: ./public/P/images/ico/ico_nodata.png
var ico_nodata = __webpack_require__(39044);
var ico_nodata_default = /*#__PURE__*/__webpack_require__.n(ico_nodata);
// EXTERNAL MODULE: ./hooks/services/queries/essential/banner/useBannerContents.ts
var useBannerContents = __webpack_require__(72204);
// EXTERNAL MODULE: ./node_modules/@yb/utils/dist/ybutil.cjs.js
var ybutil_cjs = __webpack_require__(20279);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./components/hoc/withCalendar.tsx
var withCalendar = __webpack_require__(25893);
// EXTERNAL MODULE: ./public/P/images/ico/ico_spr.png
var ico_spr = __webpack_require__(99653);
var ico_spr_default = /*#__PURE__*/__webpack_require__.n(ico_spr);
// EXTERNAL MODULE: ./hooks/services/queries/essential/contents/useContentsHoliday.ts
var useContentsHoliday = __webpack_require__(6843);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
;// CONCATENATED MODULE: ./components/product/pages/localList/desktop/filter/LocalFilterCalendar.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	display: flex;\n	width: 100%;\n	height: 100%;\n	align-items: center;\n\n	input {\n		position: relative;\n		z-index: 1;\n		width: 100%;\n		height: 100%;\n		padding: 7px 23px 7px 10px;\n		background-color: transparent;\n		box-sizing: border-box;\n		cursor: pointer;\n\n		+ label {\n			position: absolute;\n			top: 50%;\n			right: 10px;\n			display: block;\n			width: 18px;\n			height: 20px;\n			background-image: url(",
        ");\n			background-size: 400px 400px;\n			background-position: -20px 0;\n			transform: translateY(-50%);\n		}\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				position: absolute;\n				left: 0;\n				top: 36px;\n				z-index: 10;\n				border: 1px solid var(--emp-color);\n				overflow: hidden;\n			"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				width: 245px;\n				margin: 0 auto;\n			"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			table {\n				th {\n					height: 35px;\n					background-color: #fff;\n					text-align: center;\n					&:not(:last-child),\n					&:last-child {\n						border: none;\n					}\n				}\n				td {\n					height: 35px;\n					padding: 0;\n					&:not(:last-child),\n					&:last-child {\n						border: none;\n					}\n				}\n			}\n		"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 245px;\n	background-color: #fff;\n	",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	display: flex;\n	width: 100%;\n	height: 50px;\n	justify-content: center;\n	em {\n		font-size: 22px;\n		font-weight: bold;\n		color: var(--emp-color);\n		line-height: 1;\n	}\n	label {\n		font-size: var(--medium-size);\n		font-weight: normal;\n	}\n	ul {\n		top: 50px;\n		left: 50%;\n		width: 245px;\n		max-height: 155px;\n		transform: translateX(-50%);\n		> li {\n			justify-content: center;\n			padding: 0;\n		}\n	}\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: 23px;\n	width: 8px;\n	height: 8px;\n	border-left: 1px solid var(--emp-color);\n	border-bottom: 1px solid var(--emp-color);\n	background-color: transparent;\n\n	&:disabled {\n		border-color: var(--bl-color);\n	}\n\n	",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 245px;\n	table-layout: fixed;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				font-size: var(--basic-size);\n			"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				font-size: 13px;\n			"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	height: 35px;\n	padding: 10px;\n	box-sizing: border-box;\n	border-top: 1px solid var(--line-color);\n	font-size: var(--basic-size);\n	color: var(--emp-color);\n	text-align: center;\n	&:first-child {\n		color: #ff5c46;\n	}\n	&:last-child {\n		color: #4567ad;\n	}\n	",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				> span {\n					font-size: var(--basic-size);\n				}\n				&:hover {\n					> span {\n						",
        ";\n					}\n				}\n				&:first-child {\n					> span {\n						color: ",
        ";\n					}\n				}\n				&:last-child {\n					> span {\n						color: ",
        ";\n					}\n				}\n			"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n							&:hover {\n								cursor: pointer;\n								> span {\n									border-color: var(--emp-color);\n								}\n							}\n						"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				&:first-child {\n					> span {\n						color: ",
        ";\n					}\n				}\n				&:last-child {\n					> span {\n						color: ",
        ";\n					}\n				}\n				> span {\n					font-size: 13px;\n				}\n				",
        "\n			"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					background-color: var(--yellow-color);\n					color: var(--emp-color);\n					",
        "\n				"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					background-color: var(--line-color);\n					color: var(--emp-color);\n				"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					background-color: #a4bdf0;\n					color: var(--emp-color);\n				"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	box-sizing: border-box;\n	height: 35px;\n	color: ",
        ";\n	vertical-align: top;\n	text-align: left;\n	cursor: ",
        ";\n\n	",
        "\n	> span {\n		border: 1px solid transparent;\n		border-color: ",
        ";\n		box-sizing: border-box;\n		",
        "\n	}\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: center;\n	width: 100%;\n	height: 100%;\n	z-index: 1;\n	color: ",
        ";\n	&:before {\n		position: absolute;\n		top: 0;\n		left: 50%;\n		display: ",
        ';\n		width: 5px;\n		height: 5px;\n		border-radius: 100%;\n		background-color: var(--emp-color);\n		transform: translateX(-50%);\n		content: "";\n	}\n'
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	height: 35px;\n	line-height: 35px;\n	padding-left: 10px;\n	border-top: 1px solid var(--line-color);\n	background: var(--disabled-color);\n	text-align: left;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	gap: 10px;\n	background-color: transparent;\n	font-size: 14px;\n	color: #222;\n	&:before {\n		display: block;\n		width: 13px;\n		height: 14px;\n		background: url(",
        ') no-repeat;\n		background-size: 400px 400px;\n		background-position: -178px 0;\n		content: "";\n	}\n'
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}










var Select = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2aefa6c2-0"
})(_templateObject(), (ico_spr_default()));
var CalendarWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2aefa6c2-1"
})(_templateObject3(), function(props) {
    if (props.types === "filter") {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
    }
    if (props.types === "basic") {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
    }
});
var CalendarBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2aefa6c2-2"
})(_templateObject5(), function(props) {
    return props.types === "basic" && (0,styled_components_browser_esm/* css */.iv)(_templateObject4());
});
var CalendarMonth = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2aefa6c2-3"
})(_templateObject6());
var MonthButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-2aefa6c2-4"
})(_templateObject7(), function(props) {
    return props.types === "prev" ? "\n                left: 10px;\n                transform: rotate(45deg);\n            " : "\n                right: 10px;\n                transform: rotate(-135deg);\n            ";
});
var TableCalendar = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-2aefa6c2-5"
})(_templateObject8());
var Month = styled_components_browser_esm/* default.th.withConfig */.ZP.th.withConfig({
    componentId: "sc-2aefa6c2-6"
})(_templateObject11(), function(props) {
    if (props.types === "filter") {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject9());
    }
    if (props.types === "basic") {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject10());
    }
});
var ProductDays = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    componentId: "sc-2aefa6c2-7"
})(_templateObject18(), function(props) {
    return props.isActive ? "var(--emp-color)" : "#aaa";
}, function(props) {
    return props.isActive ? "pointer" : "initial";
}, function(props) {
    if (props.types === "filter") {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject12(), props.isActive && "border-color: var(--emp-color)", props.isActive ? "var(--red-color)" : "#ffc8c3", props.isActive ? "var(--blue-color)" : "#b5c2de");
    }
    if (props.types === "basic") {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject14(), props.rev ? "var(--red-color)" : "#ffc8c3", props.rev ? "var(--blue-color)" : "#b5c2de", props.rev ? (0,styled_components_browser_esm/* css */.iv)(_templateObject13()) : "");
    }
}, function(props) {
    return props.CheckedDay ? "var(--emp-color)" : "transparent";
}, function(props) {
    if (props.types === "basic" && props.rev === "can") {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject15(), props.isActive && "border-color: var(--emp-color)");
    }
    if (props.types === "basic" && props.rev === "end") {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject16());
    }
    if (props.types === "basic" && props.rev === "wait") {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject17());
    }
});
var Day = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-2aefa6c2-8"
})(_templateObject19(), function(props) {
    return props.holiday ? "var(--red-color)" : "";
}, function(props) {
    return props.today ? "block" : "none";
});
var ResetBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2aefa6c2-9"
})(_templateObject20());
var ResetButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-2aefa6c2-10"
})(_templateObject21(), (ico_spr_default()));
var LocalFilterCalendar = (0,withCalendar/* default */.Z)(function(props, ref) {
    var ref1, ref2, ref3;
    var types = "filter";
    var today = dayjs_min_default()();
    var date = props.date, isNext = props.isNext, isPrevious = props.isPrevious, rangeMonth = props.rangeMonth, dayList = props.dayList, month = props.month, clearDate = props.clearDate, dateChange = props.dateChange, monthChange = props.monthChange, nextMonth = props.nextMonth, prevMonth = props.prevMonth;
    var ref4 = (0,react.useState)(false), showCalendar = ref4[0], setShowCalendar = ref4[1];
    var ref5 = (0,react.useState)(false), showMonth = ref5[0], setShowMonth = ref5[1];
    var id = (0,react.useId)();
    var holidayFetch = (0,useContentsHoliday/* default */.ZP)(dayjs_min_default()(month).format("YYYY"), {
        staleTime: 1000 * 60 * 5
    });
    var ref6;
    var holiday = (ref6 = (ref1 = holidayFetch.data) === null || ref1 === void 0 ? void 0 : ref1.body) !== null && ref6 !== void 0 ? ref6 : [];
    (0,react.useEffect)(function() {
        if (!showCalendar) return;
        var event = function(e) {
            if (document.body.contains(e.target)) {
                !e.target.closest("#".concat(CSS.escape(id))) && setShowCalendar(false);
                !e.target.closest("#selectWrap-".concat(CSS.escape(id))) && setShowMonth(false);
                e.target.closest("#options-".concat(CSS.escape(id))) && setShowMonth(false);
            }
        };
        setTimeout(function() {
            return window.addEventListener("click", event);
        });
        return function() {
            window.removeEventListener("click", event);
        };
    }, [
        showCalendar
    ]);
    // filter data 동기화
    var getFilter = (0,filterHook/* default */.Z)().getFilter;
    var outStartDateValue = ((ref3 = (ref2 = getFilter()) === null || ref2 === void 0 ? void 0 : ref2.filter(function(i) {
        return i.key === "outStartDateList";
    })[0]) === null || ref3 === void 0 ? void 0 : ref3.value) || "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* SearchInput */.Mj, {
                    icon: "calendar",
                    type: "text",
                    readOnly: true,
                    onClick: function() {
                        setShowCalendar(!showCalendar);
                        setShowMonth(false);
                    },
                    value: (outStartDateValue === null || outStartDateValue === void 0 ? void 0 : outStartDateValue.length) === 8 ? dayjs_min_default()(outStartDateValue).format("YYYY.MM.DD") : ""
                }),
                showCalendar && /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarWrap, {
                    id: id,
                    types: types,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CalendarBox, {
                        types: types,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CalendarMonth, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_select/* SelectWrap */.vA, {
                                        width: 90,
                                        id: "selectWrap-".concat(id),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectBox */.jL, {
                                                types: "calendar",
                                                onClick: function() {
                                                    return setShowMonth(!showMonth);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectLabel */.n5, {
                                                    isActive: true,
                                                    children: month.format("YYYY.MM")
                                                })
                                            }),
                                            showMonth && /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectOptions */.PN, {
                                                id: "options-".concat(id),
                                                children: rangeMonth === null || rangeMonth === void 0 ? void 0 : rangeMonth.map(function(day, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        value: day.format("YYYYMMDD"),
                                                        onClick: function(e) {
                                                            monthChange(String(e.currentTarget.value));
                                                        },
                                                        children: day.format("YYYY.MM")
                                                    }, index);
                                                })
                                            })
                                        ]
                                    }),
                                    isPrevious && /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthButton, {
                                        types: "prev",
                                        onClick: prevMonth,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "이전달"
                                        })
                                    }),
                                    isNext && /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthButton, {
                                        types: "next",
                                        onClick: nextMonth,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "다음달"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCalendar, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                                    types: types,
                                                    children: "일"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                                    types: types,
                                                    children: "월"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                                    types: types,
                                                    children: "화"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                                    types: types,
                                                    children: "수"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                                    types: types,
                                                    children: "목"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                                    types: types,
                                                    children: "금"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                                    types: types,
                                                    children: "토"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                        children: dayList === null || dayList === void 0 ? void 0 : dayList.map(function(week, index) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("tr", {
                                                children: week.map(function(day, weekIdx) {
                                                    var dayFormat = day === null || day === void 0 ? void 0 : day.format("YYYYMMDD");
                                                    var isHoliday = !!holiday.find(function(v) {
                                                        return v.calDt === dayFormat;
                                                    });
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDays, {
                                                        types: types,
                                                        isActive: !(day < today.add(-1, "day")),
                                                        onClick: function() {
                                                            if (!(day < today.add(-1, "day"))) {
                                                                dateChange(day);
                                                                setShowCalendar(false);
                                                            }
                                                        },
                                                        CheckedDay: date && date.isSame(day),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Day, {
                                                            types: types,
                                                            today: day && today.isSame(day, "day"),
                                                            holiday: isHoliday,
                                                            children: day && day.format("DD")
                                                        })
                                                    }, weekIdx);
                                                })
                                            }, index);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResetBlock, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResetButton, {
                                    onClick: clearDate,
                                    children: "날짜 재선택"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
});
/* harmony default export */ var filter_LocalFilterCalendar = (LocalFilterCalendar);

;// CONCATENATED MODULE: ./components/product/pages/localList/desktop/filter/LocalSideFilter.tsx























/* 출발일정 */ var StartDate = function(prop) {
    var ref, ref1, ref2;
    var ref3 = (0,filterHook/* default */.Z)(), getFilter = ref3.getFilter, setFilter = ref3.setFilter, removeFilter = ref3.removeFilter;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), popOpen = ref4[0];
    var monList = (ref = prop.monList) === null || ref === void 0 ? void 0 : ref.replaceAll("|", "").split("^");
    var ref5 = (0,react.useState)(), minDate = ref5[0], setMinDate = ref5[1];
    var ref6 = (0,react.useState)(), maxDate = ref6[0], setMaxDate = ref6[1];
    var ref7 = (0,react.useState)(false), show = ref7[0], setShow = ref7[1];
    var ref8 = (0,react.useState)(), monValue = ref8[0], setMonValue = ref8[1];
    var outStartDateValue = ((ref2 = (ref1 = getFilter()) === null || ref1 === void 0 ? void 0 : ref1.filter(function(i) {
        return i.key === "outStartDateList";
    })[0]) === null || ref2 === void 0 ? void 0 : ref2.value) || "";
    /* 달력, 기본값 초기화 */ (0,react.useEffect)(function() {
        /* 월달력 */ if (outStartDateValue.length === 6) {
            var storeMonValue = dayjs_min_default()(outStartDateValue).format("YYYY년MM월") || "출발월 전체";
            setMonValue(storeMonValue);
        } else if (monList) {
            var ref = [
                monList[0],
                monList[monList.length - 1]
            ], firstMon = ref[0], lastMon = ref[1];
            setMinDate(firstMon);
            setMaxDate(lastMon);
            setMonValue("출발월 전체");
        }
    }, [
        prop,
        monList,
        outStartDateValue
    ]);
    var handleConfirmAndSetFilter = function(key, value, text) {
        var ref;
        var setArr = (ref = getFilter()) === null || ref === void 0 ? void 0 : ref.filter(function(v) {
            return v.key !== "outStartDateList" && (value.length === 6 || v.key !== "wdayList");
        });
        var afterConfirm = function() {
            setArr.push({
                key: key,
                value: value,
                text: text
            });
            setFilter(setArr);
            return false;
        };
        popOpen(function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                alertType: "confirm",
                text: "출발 일정 조건을 변경하시는 경우<br/>기존 설정하신 출발 일정은 초기화 됩니다.<br/>출발 일정 조건을 변경하시겠습니까?",
                afterConfirm: function() {
                    return typeof afterConfirm === "function" && afterConfirm();
                }
            }));
        });
        return false;
    };
    var handleMonList = function(e) {
        var ref;
        var value = e.target.getAttribute("value");
        var text = dayjs_min_default()(value.toString()).format("YYYY년MM월 출발");
        var setArr = (ref = getFilter()) === null || ref === void 0 ? void 0 : ref.filter(function(v) {
            return v.key !== "outStartDateList";
        });
        setShow(false);
        if (outStartDateValue.length === 8) {
            return handleConfirmAndSetFilter("outStartDateList", value.toString(), text);
        }
        if (value === "ALL") {
            removeFilter("outStartDateList");
        } else {
            setArr.push({
                key: "outStartDateList",
                value: value.toString(),
                text: text
            });
            setFilter(setArr);
        }
    };
    var handleCalendar = function(date) {
        var ref, ref1, ref2;
        var setArr = (ref = getFilter()) === null || ref === void 0 ? void 0 : ref.filter(function(v) {
            return v.key !== "outStartDateList" && v.key !== "wdayList";
        });
        var text = "".concat(dayjs_min_default()(date).format("YYYY.MM.DD"), " 출발");
        var wday = ((ref2 = (ref1 = getFilter()) === null || ref1 === void 0 ? void 0 : ref1.filter(function(i) {
            return i.key === "wdayList";
        })[0]) === null || ref2 === void 0 ? void 0 : ref2.value) || "";
        if (outStartDateValue.length === 6 || wday.length > 0) {
            return handleConfirmAndSetFilter("outStartDateList", date, text);
        }
        if (!date) {
            removeFilter("outStartDateList");
            return;
        }
        setArr.push({
            key: "outStartDateList",
            value: date,
            text: text
        });
        setFilter(setArr);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_filter/* OptionWrap */.IZ, {
            show: prop.active && "show",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                direction: "column",
                gap: "10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_select/* SelectWrap */.vA, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectBox */.jL, {
                                onClick: function() {
                                    return setShow(!show);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectLabel */.n5, {
                                    children: monValue
                                })
                            }),
                            show && /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_select/* SelectOptions */.PN, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        onClick: handleMonList,
                                        value: "ALL",
                                        children: "출발월 전체"
                                    }),
                                    monList && monList.map(function(item, index) {
                                        var text = "".concat(item.substring(0, 4), "년").concat(item.substring(4, 6), "월");
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            onClick: handleMonList,
                                            value: item,
                                            children: text
                                        }, index);
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* FilterCalendarWrap */.NV, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_LocalFilterCalendar, {
                            minDate: minDate,
                            maxDate: maxDate,
                            value: outStartDateValue,
                            onDateChange: function(date) {
                                if (date === null) {
                                    removeFilter("outStartDateList");
                                    return;
                                }
                                var thisDate = date ? date.format("YYYYMMDD") : "";
                                handleCalendar(thisDate);
                            }
                        })
                    })
                ]
            })
        })
    });
};
/* 출발요일 */ var StartDay = function(prop) {
    var ref, ref1, ref2;
    var ref3 = (0,filterHook/* default */.Z)(), getFilter = ref3.getFilter, addFilter = ref3.addFilter, setFilter = ref3.setFilter, removeFilter = ref3.removeFilter;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), popOpen = ref4[0];
    var wdayListData = (ref = prop.wdayList) === null || ref === void 0 ? void 0 : ref.replaceAll("|", "").split("^");
    var wdayList = wdayListData && [
        "전체"
    ].concat((0,_to_consumable_array/* default */.Z)(wdayListData));
    var outStartDateValue = ((ref2 = (ref1 = getFilter()) === null || ref1 === void 0 ? void 0 : ref1.filter(function(i) {
        return i.key === "outStartDateList";
    })[0]) === null || ref2 === void 0 ? void 0 : ref2.value) || "";
    var handleConfirmAndSetFilter = function(key, value, text) {
        var ref;
        var setArr = (ref = getFilter()) === null || ref === void 0 ? void 0 : ref.filter(function(v) {
            return v.key !== "outStartDateList";
        });
        var afterConfirm = function() {
            setArr.push({
                key: key,
                value: value,
                text: text
            });
            setFilter(setArr);
            return false;
        };
        popOpen(function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                alertType: "confirm",
                text: "출발 일정 조건을 변경하시는 경우<br/>기존 설정하신 출발 일정은 초기화 됩니다. <br/>출발 일정 조건을 변경하시겠습니까?",
                afterConfirm: function() {
                    return typeof afterConfirm === "function" && afterConfirm();
                }
            }));
        });
        return false;
    };
    var handleWdayList = function(e) {
        var _target = e.target, value = _target.value, checked = _target.checked;
        var text = "".concat(value, "요일 출발");
        if (value === "전체") return removeFilter("wdayList");
        if (outStartDateValue.length === 8) {
            return handleConfirmAndSetFilter("wdayList", value, text);
        }
        if (checked) addFilter("wdayList", value, text);
        if (!checked) removeFilter("wdayList", value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_filter/* OptionWrap */.IZ, {
            show: prop.active && "show",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* FilterOptionList */.W$, {
                children: [
                    "전체",
                    "월",
                    "화",
                    "수",
                    "목",
                    "금",
                    "토",
                    "일"
                ].map(function(item, index) {
                    var ref, ref1;
                    return (wdayList === null || wdayList === void 0 ? void 0 : wdayList.indexOf(item)) > -1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "checkbox",
                                id: "wdayList".concat(index),
                                onChange: handleWdayList,
                                value: item,
                                checked: ((ref = getFilter()) === null || ref === void 0 ? void 0 : ref.some(function(v) {
                                    return v.value === item;
                                })) || ((ref1 = getFilter()) === null || ref1 === void 0 ? void 0 : ref1.filter(function(v) {
                                    return v.key === "wdayList";
                                }).length) === 0 && item === "전체"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "wdayList".concat(index),
                                children: item
                            })
                        ]
                    }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: item
                        })
                    }, index);
                })
            })
        })
    });
};
/* 출발시간 */ var StartTime = function(prop) {
    var ref;
    var outDeprtFgListData = (ref = prop.outDeprtFgList) === null || ref === void 0 ? void 0 : ref.replaceAll("|", "").split("^");
    var outDeprtFgList = outDeprtFgListData && [
        "전체"
    ].concat((0,_to_consumable_array/* default */.Z)(outDeprtFgListData));
    var ref1 = (0,filterHook/* default */.Z)(), getFilter = ref1.getFilter, addFilter = ref1.addFilter, removeFilter = ref1.removeFilter;
    var handleOutDeprtFgList = function(e) {
        var _target = e.target, value = _target.value, checked = _target.checked;
        if (value === "전체") return removeFilter("outDeprtFgList");
        checked && addFilter("outDeprtFgList", value, "".concat(value, " 출발"));
        !checked && removeFilter("outDeprtFgList", value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_filter/* OptionWrap */.IZ, {
            show: prop.active && "show",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* GridListWrap */.Wt, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* FilterOptionList */.W$, {
                    children: outDeprtFgList && outDeprtFgList.map(function(item, index) {
                        var ref, ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "checkbox",
                                    id: "outDeprtFgList".concat(index),
                                    value: item,
                                    onChange: handleOutDeprtFgList,
                                    checked: ((ref = getFilter()) === null || ref === void 0 ? void 0 : ref.some(function(v) {
                                        return v.value === item;
                                    })) || ((ref1 = getFilter()) === null || ref1 === void 0 ? void 0 : ref1.filter(function(v) {
                                        return v.key === "outDeprtFgList";
                                    }).length) === 0 && item === "전체"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "outDeprtFgList".concat(index),
                                    children: item
                                })
                            ]
                        }, index);
                    })
                })
            })
        })
    });
};
/* 출발지(공항) */ var StartAir = function(prop) {
    var ref;
    var outCityListData = (ref = prop.outCityList) === null || ref === void 0 ? void 0 : ref.replaceAll("|", "").split("^");
    var outCityList = outCityListData && [
        "전체"
    ].concat((0,_to_consumable_array/* default */.Z)(outCityListData));
    var ref1 = (0,filterHook/* default */.Z)(), getFilter = ref1.getFilter, addFilter = ref1.addFilter, removeFilter = ref1.removeFilter;
    var handleOutCityList = function(e) {
        var _target = e.target, value = _target.value, checked = _target.checked;
        checked && addFilter("outCityDiviNm", value, "".concat(value, " 출발"));
        !checked && removeFilter("outCityDiviNm", value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_filter/* OptionWrap */.IZ, {
            show: prop.active && "show",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* GridListWrap */.Wt, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* FilterOptionList */.W$, {
                    children: outCityList && outCityList.map(function(item, index) {
                        var ref, ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "checkbox",
                                    id: "outCityList".concat(index),
                                    value: item,
                                    onChange: handleOutCityList,
                                    checked: ((ref = getFilter()) === null || ref === void 0 ? void 0 : ref.some(function(v) {
                                        return v.value === item;
                                    })) || ((ref1 = getFilter()) === null || ref1 === void 0 ? void 0 : ref1.filter(function(v) {
                                        return v.key === "outCityDiviNm";
                                    }).length) === 0 && item === "전체"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "outCityList".concat(index),
                                    children: item
                                })
                            ]
                        }, index);
                    })
                })
            })
        })
    });
};
/* 여행기간 */ var TravelDays = function(prop) {
    var ref;
    var evNightListData = (ref = prop.evNightList) === null || ref === void 0 ? void 0 : ref.replaceAll("|", "").split("^");
    var evNightList = evNightListData && [
        "전체"
    ].concat((0,_to_consumable_array/* default */.Z)(evNightListData));
    var ref1 = (0,filterHook/* default */.Z)(), getFilter = ref1.getFilter, addFilter = ref1.addFilter, removeFilter = ref1.removeFilter;
    var handleEvNightList = function(e) {
        var ref, ref1;
        var _target = e.target, text = _target.value, checked = _target.checked;
        if (text === "전체") return removeFilter("evDayCntList");
        var value = (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.replace("일", "");
        checked && addFilter("evDayCntList", value, text);
        !checked && removeFilter("evDayCntList", value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_filter/* OptionWrap */.IZ, {
            show: prop.active && "show",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* GridListWrap */.Wt, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* FilterOptionList */.W$, {
                    children: evNightList && evNightList.map(function(item, index) {
                        var ref, ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "checkbox",
                                    id: "evNightList".concat(index),
                                    value: item,
                                    onChange: handleEvNightList,
                                    checked: ((ref = getFilter()) === null || ref === void 0 ? void 0 : ref.some(function(v) {
                                        return v.text === item;
                                    })) || ((ref1 = getFilter()) === null || ref1 === void 0 ? void 0 : ref1.filter(function(v) {
                                        return v.key === "evDayCntList";
                                    }).length) === 0 && item === "전체"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "evNightList".concat(index),
                                    children: item
                                })
                            ]
                        }, index);
                    })
                })
            })
        })
    });
};
/* 여행예산(1인 기준) */ var TravelBudget = function(prop) {
    var ref;
    var ref1 = (0,react.useState)({
        minPrice: "",
        maxPrice: ""
    }), price = ref1[0], setPrice = ref1[1];
    var ref2 = (0,filterHook/* default */.Z)(), getFilter = ref2.getFilter, setFilter = ref2.setFilter;
    var keys = [
        "minPrice",
        "maxPrice"
    ];
    var setArr = ((ref = getFilter()) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
        return !keys.includes(item.key);
    })) || [];
    var addFilter = function() {
        var minPrice = price.minPrice === "" ? prop.minPrice : price.minPrice.replace(/[^0-9]/g, "");
        var maxPrice = price.maxPrice === "" ? prop.maxPrice : price.maxPrice.replace(/[^0-9]/g, "");
        setArr.push({
            key: "minPrice",
            value: minPrice,
            text: "".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(minPrice), "원")
        });
        setArr.push({
            key: "maxPrice",
            value: maxPrice,
            text: "".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(maxPrice), "원")
        });
        setFilter(setArr);
    };
    var handleChage = function(e) {
        var _target = e.target, id = _target.id, value = _target.value;
        setPrice((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, price), (0,_define_property/* default */.Z)({}, id, value)));
    };
    var handleKeyup = function(e) {
        var _target = e.target, id = _target.id, value = _target.value;
        if (e.keyCode === 13) {
            addFilter();
        } else {
            setPrice((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, price), (0,_define_property/* default */.Z)({}, id, ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(value.replace(/[^0-9]/g, "")))));
        }
    };
    var handleBlur = function() {
        if (price.minPrice.length + price.maxPrice.length > 0) {
            addFilter();
        } else {
            setArr = getFilter().filter(function(v) {
                return !keys.includes(v.key);
            });
            setFilter(setArr);
        }
    };
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3;
        /* 초기값 세팅*/ var storeMinPrice = (ref1 = (ref = getFilter()) === null || ref === void 0 ? void 0 : ref.filter(function(i) {
            return i.key === "minPrice";
        })[0]) === null || ref1 === void 0 ? void 0 : ref1.value;
        var storeMaxPrice = (ref3 = (ref2 = getFilter()) === null || ref2 === void 0 ? void 0 : ref2.filter(function(i) {
            return i.key === "maxPrice";
        })[0]) === null || ref3 === void 0 ? void 0 : ref3.value;
        if (storeMinPrice && storeMaxPrice) {
            var ref4, ref5;
            var minPrice = storeMinPrice === ((ref4 = prop.minPrice) === null || ref4 === void 0 ? void 0 : ref4.replace(/[^0-9]/g, "")) ? "" : storeMinPrice;
            var maxPrice = storeMaxPrice === ((ref5 = prop.maxPrice) === null || ref5 === void 0 ? void 0 : ref5.replace(/[^0-9]/g, "")) ? "" : storeMaxPrice;
            setPrice((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, price), {
                minPrice: minPrice,
                maxPrice: maxPrice
            }));
        }
    }, [
        getFilter()
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_filter/* OptionWrap */.IZ, {
            show: prop.active && "show",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_filter/* OptionTextField */.Lf, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "text",
                        id: "minPrice",
                        value: price.minPrice,
                        placeholder: "₩".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(prop.minPrice)),
                        onChange: handleChage,
                        onKeyUp: handleKeyup,
                        onBlur: handleBlur
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "~"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "text",
                        id: "maxPrice",
                        value: price.maxPrice,
                        placeholder: "₩".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(prop.maxPrice)),
                        onChange: handleChage,
                        onKeyUp: handleKeyup,
                        onBlur: handleBlur
                    })
                ]
            })
        })
    });
};
/* 이용교통 */ var UseTraffic = function(prop) {
    var ref;
    var airListData = ((ref = prop.airList) === null || ref === void 0 ? void 0 : ref.replaceAll("|", "").split("^")) || [];
    var airList = [
        {
            code: "ALL",
            name: "전체"
        }
    ];
    for(var i = 0; i < airListData.length; i += 2){
        var code = airListData[i];
        var name = airListData[i + 1];
        airList.push({
            code: code,
            name: name
        });
    }
    var ref1 = (0,filterHook/* default */.Z)(), getFilter = ref1.getFilter, addFilter = ref1.addFilter, removeFilter = ref1.removeFilter;
    var handleAirList = function(e) {
        var _target = e.target, value = _target.value, checked = _target.checked;
        if (value === "ALL") return removeFilter("airCd");
        var text = e.target.parentNode.textContent;
        checked && addFilter("airCd", value, text);
        !checked && removeFilter("airCd", value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_filter/* OptionWrap */.IZ, {
            show: prop.active && "show",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* FilterOptionList */.W$, {
                children: airList && airList.map(function(item, index) {
                    var ref, ref1;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "checkbox",
                                id: "airline-".concat(item.code),
                                value: item.code,
                                onChange: handleAirList,
                                checked: ((ref = getFilter()) === null || ref === void 0 ? void 0 : ref.some(function(v) {
                                    return v.value === item.code;
                                })) || ((ref1 = getFilter()) === null || ref1 === void 0 ? void 0 : ref1.filter(function(v) {
                                    return v.key === "airCd";
                                }).length) === 0 && item.name === "전체"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "airline-".concat(item.code),
                                children: item.name
                            })
                        ]
                    }, index);
                })
            })
        })
    });
};
/* 상품특징 */ var ProductFeatures = function(prop) {
    var featuresListData = prop.featuresList.replaceAll("|", "").split("^");
    var featuresList = [
        {
            code: "PC00",
            name: "전체",
            divi: "PC"
        }
    ];
    for(var i = 0; i < featuresListData.length; i += 3){
        var code = featuresListData[i];
        var name = featuresListData[i + 1];
        var divi = featuresListData[i + 2];
        featuresList.push({
            code: code,
            name: name,
            divi: divi
        });
    }
    var ref = (0,filterHook/* default */.Z)(), getFilter = ref.getFilter, addFilter = ref.addFilter, removeFilter = ref.removeFilter;
    var handleFeaturesList = function(e) {
        var _target = e.target, value = _target.value, checked = _target.checked;
        if (value === "PC00") return removeFilter("goodsFeaturesList");
        var text = e.target.parentNode.textContent;
        checked && addFilter("goodsFeaturesList", value, text);
        !checked && removeFilter("goodsFeaturesList", value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_filter/* OptionWrap */.IZ, {
            show: prop.active && "show",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* FilterOptionList */.W$, {
                children: featuresList && featuresList.map(function(item, index) {
                    var ref, ref1;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "checkbox",
                                id: "features".concat(item.code),
                                value: item.code,
                                onChange: handleFeaturesList,
                                checked: ((ref = getFilter()) === null || ref === void 0 ? void 0 : ref.some(function(v) {
                                    return v.value === item.code;
                                })) || ((ref1 = getFilter()) === null || ref1 === void 0 ? void 0 : ref1.filter(function(v) {
                                    return v.key === "goodsFeaturesList";
                                }).length) === 0 && item.name === "전체"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "features".concat(item.code),
                                children: item.name
                            })
                        ]
                    }, index);
                })
            })
        })
    });
};
/* 프로모션 */ var Promotion = function(prop) {
    var promotionListData = prop.promotionList.replaceAll("|", "").split("^");
    var promotionList = [
        {
            code: "ALL",
            name: "전체"
        }
    ];
    for(var i = 0; i < promotionListData.length; i += 2){
        var code = promotionListData[i];
        var name = promotionListData[i + 1];
        promotionList.push({
            code: code,
            name: name
        });
    }
    var ref = (0,filterHook/* default */.Z)(), getFilter = ref.getFilter, addFilter = ref.addFilter, removeFilter = ref.removeFilter;
    var handlePromotionList = function(e) {
        var _target = e.target, value = _target.value, checked = _target.checked;
        if (value === "ALL") return removeFilter("goodsPromotion");
        var text = e.target.parentNode.innerText;
        checked && addFilter("goodsPromotion", value, text);
        !checked && removeFilter("goodsPromotion", value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_filter/* OptionWrap */.IZ, {
            show: prop.active && "show",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* FilterOptionList */.W$, {
                children: promotionList && promotionList.map(function(item, index) {
                    var ref, ref1;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "checkbox",
                                id: "promotion".concat(item.code),
                                value: item.code,
                                onChange: handlePromotionList,
                                checked: ((ref = getFilter()) === null || ref === void 0 ? void 0 : ref.some(function(v) {
                                    return v.value === item.code;
                                })) || ((ref1 = getFilter()) === null || ref1 === void 0 ? void 0 : ref1.filter(function(v) {
                                    return v.key === "goodsPromotion";
                                }).length) === 0 && item.name === "전체"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "promotion".concat(item.code),
                                children: item.name
                            })
                        ]
                    }, index);
                })
            })
        })
    });
};
/* 여행구성원 */ var TravelMember = function(prop) {
    var tmemberListData = prop.tmemberList.replaceAll("|", "").split("^");
    var tmemberList = [];
    for(var i = 0; i < tmemberListData.length; i += 2){
        var code = tmemberListData[i];
        var name = tmemberListData[i + 1];
        tmemberList.push({
            code: code,
            name: name
        });
    }
    var ref = (0,filterHook/* default */.Z)(), getFilter = ref.getFilter, addFilter = ref.addFilter, removeFilter = ref.removeFilter;
    var handleTmemberList = function(e) {
        var _target = e.target, value = _target.value, checked = _target.checked;
        var text = e.target.parentNode.innerText;
        checked && addFilter("goodsTmember", value, text);
        !checked && removeFilter("goodsTmember", value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_filter/* OptionWrap */.IZ, {
            show: prop.active && "show",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* FilterOptionList */.W$, {
                children: tmemberList && tmemberList.map(function(item, index) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "checkbox",
                                id: "tmemberList".concat(item.code),
                                value: item.code,
                                onChange: handleTmemberList,
                                checked: ((ref = getFilter()) === null || ref === void 0 ? void 0 : ref.some(function(v) {
                                    return v.value === item.code;
                                })) || false
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "tmemberList".concat(item.code),
                                children: item.name
                            })
                        ]
                    }, index);
                })
            })
        })
    });
};
/* 상품 검색*/ var GoodsNm = function() {
    var ref, ref1;
    var goodsNmRef = (0,react.useRef)(null);
    var ref2 = (0,filterHook/* default */.Z)(), getFilter = ref2.getFilter, setFilter = ref2.setFilter;
    var addFilter = function(value) {
        var ref;
        var setArr = (ref = getFilter()) === null || ref === void 0 ? void 0 : ref.filter(function(v) {
            return v.key !== "goodsNm";
        });
        value && setArr.push({
            key: "goodsNm",
            value: value,
            text: value
        });
        setFilter(setArr);
    };
    var handleKeyup = function(e) {
        if (e.keyCode === 13) {
            var value = e.target.value;
            addFilter(value);
        }
    };
    var handleClick = function() {
        return addFilter(goodsNmRef.current.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_filter/* SearchWrap */.Hu, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_filter/* Search */.ol, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "text",
                    id: "goodsNm",
                    placeholder: "상품 상세 검색",
                    onKeyUp: handleKeyup,
                    ref: goodsNmRef,
                    defaultValue: (ref1 = (ref = getFilter()) === null || ref === void 0 ? void 0 : ref.filter(function(v) {
                        return v.key === "goodsNm";
                    })[0]) === null || ref1 === void 0 ? void 0 : ref1.text
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "submit",
                    onClick: handleClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "검색"
                    })
                })
            ]
        })
    });
};
var Banner = function(param) {
    var item = param.item;
    var ref = (0,react.useState)(false), isError = ref[0], setIsError = ref[1];
    var imageOnError = function(e) {
        setIsError(true);
    };
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("pkg_select_promo_locallist", (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
        selectDiv: "localListFilter"
    })).taggingClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* BannerImg */.tS, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL).concat(item.link) || "#",
            target: (0,commonUtil/* getTarget */.U9)(item.target),
            onClick: function() {
                return taggingClick();
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: !isError ? "".concat(config_public/* default.ENV_CIMG_CDN_URL */.Z.ENV_CIMG_CDN_URL).concat(item.imgPath) : (ico_nodata_default()),
                width: 240,
                height: 140,
                alt: item.alt,
                onError: imageOnError
            })
        })
    });
};
/* 프로모션 배너 */ var BannerPromotion = function() {
    var ref;
    var bannerPromotionFetch = (0,useBannerContents/* default */.ZP)("GOLI");
    var bannerPromotion = (ref = bannerPromotionFetch.data) === null || ref === void 0 ? void 0 : ref.body;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: bannerPromotion && bannerPromotion.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, {
                item: item
            }, index);
        })
    });
};
var LocalSideFilterComponent = function(filter) {
    var ref = (0,react.useState)(0), active = ref[0], setActive = ref[1];
    var getFilterList = (0,react.useMemo)(function() {
        /* 제휴 분기처리 작업 필요 */ var arr = [];
        arr.push({
            title: "출발 일정",
            contents: StartDate
        });
        arr.push({
            title: "출발 요일",
            contents: StartDay
        });
        arr.push({
            title: "출발 시간",
            contents: StartTime
        });
        arr.push({
            title: "출발지(공항)",
            contents: StartAir
        });
        arr.push({
            title: "여행기간",
            contents: TravelDays
        });
        arr.push({
            title: "여행예산(1인 기준)",
            contents: TravelBudget
        });
        arr.push({
            title: "이용교통",
            contents: UseTraffic
        });
        filter.featuresList && arr.push({
            title: "상품특징",
            contents: ProductFeatures
        });
        filter.promotionList && arr.push({
            title: "프로모션",
            contents: Promotion
        });
        filter.tmemberList && arr.push({
            title: "여행구성원",
            contents: TravelMember
        });
        return arr;
    }, [
        filter
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GoodsNm, {}),
            getFilterList.length > 0 && getFilterList.map(function(item, index) {
                var Contents = item.contents;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_filter/* OptionTitle */.iu, {
                            onClick: function() {
                                return setActive(function(value) {
                                    return value === index ? null : index;
                                });
                            },
                            active: active === index,
                            children: item.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Contents, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, filter), {
                            active: active === index
                        }))
                    ]
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerPromotion, {})
        ]
    });
};
/* 제휴 분기처리 작업 필요 */ var LocalSideFilter = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "SideFilter Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalSideFilterComponent, (0,src_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var filter_LocalSideFilter = (LocalSideFilter);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./components/product/common/popup/desktop/EventListPopup/EventListPopup.tsx + 4 modules
var EventListPopup = __webpack_require__(89071);
// EXTERNAL MODULE: ./framework/ui/desktop/button/index.ts + 7 modules
var desktop_button = __webpack_require__(9873);
;// CONCATENATED MODULE: ./framework/ui/desktop/layout/LoadingBox.tsx

function LoadingBox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	min-height: 300px;\n"
    ]);
    LoadingBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LoadingBox_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: 50%;\n	left: 50%;\n	display: flex;\n	flex-direction: column;\n	justify-content: center;\n	align-items: center;\n	gap: 30px;\n	transform: translate(-50%, -50%);\n\n	div {\n		display: flex;\n		gap: 5px;\n	}\n\n	span {\n		position: relative;\n		display: inline-block;\n		width: 12px;\n		height: 12px;\n		border-radius: 50%;\n		background-color: var(--yellow-color);\n		animation: loading 1.5s linear infinite;\n\n		&:nth-child(1) {\n			animation-delay: 0.1s;\n		}\n		&:nth-child(2) {\n			animation-delay: 0.2s;\n		}\n		&:nth-child(3) {\n			animation-delay: 0.3s;\n		}\n		&:nth-child(4) {\n			animation-delay: 0.4s;\n		}\n		&:nth-child(5) {\n			animation-delay: 0.5s;\n		}\n		&:nth-child(6) {\n			animation-delay: 0.6s;\n		}\n	}\n\n	@keyframes loading {\n		0% {\n			transform: translateY(0px) rotate(45deg);\n			background-color: #ddd;\n		}\n\n		50% {\n			transform: translateY(-20px) rotate(45deg);\n			background-color: #ddd;\n			opacity: 0;\n		}\n		100% {\n			transform: translateY(0px) rotate(45deg);\n			background-color: var(--yellow-color);\n			border-bottom-right-radius: 0;\n		}\n	}\n"
    ]);
    LoadingBox_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LoadingBox_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	text-align: center;\n\n	em {\n		color: var(--yellow-color);\n	}\n"
    ]);
    LoadingBox_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Wrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2bc5ae8e-0"
})(LoadingBox_templateObject());
var Box = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2bc5ae8e-1"
})(LoadingBox_templateObject1());
var Text = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-2bc5ae8e-2"
})(LoadingBox_templateObject2());
var LoadingBox = function(props) {
    var children = props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrap, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ var layout_LoadingBox = (LoadingBox);

// EXTERNAL MODULE: ./hooks/services/queries/prdt/goods/useGoodsByMenu.ts
var useGoodsByMenu = __webpack_require__(73225);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/goods/useGoodsCompare.ts
var useGoodsCompare = __webpack_require__(82834);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/goods/useGoodsOneAvailEvent.ts
var useGoodsOneAvailEvent = __webpack_require__(51820);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./framework/ui/desktop/list/index.ts + 3 modules
var list = __webpack_require__(73255);
;// CONCATENATED MODULE: ./components/product/pages/localList/desktop/filter/LocalSortFilter.tsx




var LocalSortFilterComponent = function() {
    var ref = (0,filterHook/* default */.Z)(), getFilter = ref.getFilter, setFilter = ref.setFilter;
    var key = "sort";
    var Rating = [
        // 상품리스트 필터
        {
            text: "추천순",
            value: "sortOrder",
            key: key,
            asc: true
        },
        {
            text: "인기순",
            value: "rervTourlistCnt",
            key: key,
            asc: false
        },
        {
            text: "낮은가격순",
            value: "minPrice",
            key: key,
            asc: true
        },
        {
            text: "높은가격순",
            value: "minPrice",
            key: key,
            asc: false
        },
        {
            text: "고객평점순",
            value: "rvwAvgScore",
            key: key,
            asc: false
        }, 
    ];
    var handleClick = function(e) {
        var ref;
        var _dataset = e.target.dataset, value = _dataset.value, text = _dataset.text, asc = _dataset.asc;
        var setArr = (ref = getFilter()) === null || ref === void 0 ? void 0 : ref.filter(function(v) {
            return v.key !== key;
        });
        value && setArr.push({
            key: key,
            value: value,
            text: text,
            asc: asc === "true"
        });
        setFilter(setArr);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* StackList */.fe, {
        cursor: "pointer",
        children: Rating.map(function(item, index) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(list/* StackListItem */.jS, {
                onClick: handleClick,
                isActive: ((ref = getFilter()) === null || ref === void 0 ? void 0 : ref.some(function(v) {
                    return v.text === item.text && v.key === key;
                })) || false,
                "data-asc": item.asc,
                "data-value": item.value,
                "data-text": item.text,
                children: item.text
            }, index);
        })
    });
};
var LocalSortFilter = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "SortFilter Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalSortFilterComponent, {})
    });
};
/* harmony default export */ var filter_LocalSortFilter = (LocalSortFilter);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./components/style/productlist/compareproduct.tsx

function compareproduct_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	> table {\n		th {\n			height: 50px;\n			padding: 0 10px;\n			text-align: left;\n		}\n		td {\n			height: 50px;\n			padding: 0 10px;\n			text-align: left;\n			vertical-align: top;\n			> div {\n				padding: 15px 0;\n			}\n		}\n		tr {\n			&:first-child {\n				td {\n					vertical-align: middle;\n				}\n			}\n			&:last-child {\n				th:not(:first-child) {\n					text-align: center;\n					font-size: 13px;\n				}\n				td {\n					padding: 0;\n					height: 35px;\n					> div {\n						padding: 0 10px;\n					}\n				}\n			}\n		}\n	}\n"
    ]);
    compareproduct_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function compareproduct_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 16px;\n	color: var(--emp-color);\n	vertical-align: top;\n"
    ]);
    compareproduct_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function compareproduct_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	width: 100%;\n	height: auto;\n	font-size: 16px;\n	text-align: right;\n	vertical-align: middle;\n	color: var(--red-color);\n	em {\n		font-family: "pr-font-medium";\n	}\n'
    ]);
    compareproduct_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function compareproduct_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	justify-content: center;\n	margin-top: 40px;\n"
    ]);
    compareproduct_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var TableWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dc85e90c-0"
})(compareproduct_templateObject());
var ProductExplain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dc85e90c-1"
})(compareproduct_templateObject1());
var ProductPrice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dc85e90c-2"
})(compareproduct_templateObject2());
var BtnBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dc85e90c-3"
})(compareproduct_templateObject3());


// EXTERNAL MODULE: ./framework/ui/desktop/editor/index.tsx
var editor = __webpack_require__(58771);
// EXTERNAL MODULE: ./framework/ui/desktop/popup/index.ts + 2 modules
var popup = __webpack_require__(7794);
// EXTERNAL MODULE: ./framework/ui/desktop/table/index.ts + 1 modules
var table = __webpack_require__(5540);
// EXTERNAL MODULE: ./framework/utils/useConfigureAxios.ts + 43 modules
var utils_useConfigureAxios = __webpack_require__(21741);
;// CONCATENATED MODULE: ./hooks/services/queries/prdt/event/useEventCompare.ts






/** ```
 * 상품 비교하기
 *   `/prdt/api/goods/compare
 * parameter
 *   `compareGoodsCd` 상품코드 ex) "ATP1127,ATP1164"
 * ```*/ var key = "useEventCompare";
var getPath = function(data) {
    if (!data.compareGoodsCd || !data.compareDate || !data.compareSingleTypeCd || !data.compareDspSid) return null;
    return "".concat(config_public/* default.ENV_PRODUCT_API_BASEPATH */.Z.ENV_PRODUCT_API_BASEPATH, "/api/event/compare?compareGoodsCd=").concat(data.compareGoodsCd, "&compareDate=").concat(data.compareDate, "&compareDspSid=").concat(data.compareDspSid, "&compareSingleTypeCd=").concat(data.compareSingleTypeCd);
};
/** ```
 * 상품 비교하기
 *   `/prdt/api/goods/compare
 * parameter
 *   `compareGoodsCd` 상품코드 ex) "ATP1127,ATP1164"
 * ```*/ var eventCompareAsync = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
        var result, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        (0,utils_useConfigureAxios/* default */.Z)(getPath(data), (_tmp.method = "GET", _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function eventCompareAsync(data) {
        return _ref.apply(this, arguments);
    };
}();
/** ```
 * 상품 비교하기
 *   `/prdt/api/goods/compare
 * parameter
 *   `compareGoodsCd` 상품코드 ex) "ATP1127,ATP1164"
 * ```*/ var useEventCompare = function(data, options) {
    return useQuery(_object_spread({
        queryKey: [
            key,
            getPath(data)
        ],
        queryFn: function() {
            return useConfigureAxios({
                url: getPath(data)
            }).then(function(r) {
                return r.data;
            });
        }
    }, options));
};
/* harmony default export */ var event_useEventCompare = ((/* unused pure expression or super */ null && (useEventCompare)));


;// CONCATENATED MODULE: ./components/product/pages/localList/desktop/goods/LocalCompareGoodsCalendar.tsx




function LocalCompareGoodsCalendar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				position: absolute;\n				left: 0;\n				bottom: -304px;\n				z-index: 10;\n				border: 1px solid var(--emp-color);\n				overflow: hidden;\n			"
    ]);
    LocalCompareGoodsCalendar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LocalCompareGoodsCalendar_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				position: relative;\n				width: 245px;\n				height: 330px;\n				margin: 0 auto;\n			"
    ]);
    LocalCompareGoodsCalendar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LocalCompareGoodsCalendar_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        "\n"
    ]);
    LocalCompareGoodsCalendar_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function LocalCompareGoodsCalendar_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			table {\n				th {\n					height: 35px;\n					background-color: #fff;\n					text-align: center;\n					&:not(:last-child),\n					&:last-child {\n						border: none;\n					}\n				}\n				td {\n					height: 35px;\n					padding: 0;\n					&:not(:last-child),\n					&:last-child {\n						border: none;\n					}\n				}\n			}\n		"
    ]);
    LocalCompareGoodsCalendar_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function LocalCompareGoodsCalendar_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 245px;\n	background-color: #fff;\n	",
        "\n"
    ]);
    LocalCompareGoodsCalendar_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function LocalCompareGoodsCalendar_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	display: flex;\n	width: 100%;\n	height: 50px;\n	justify-content: center;\n	em {\n		font-size: 22px;\n		font-weight: bold;\n		color: var(--emp-color);\n		line-height: 1;\n	}\n	label {\n		font-size: var(--medium-size);\n		font-weight: normal;\n	}\n	ul {\n		top: 50px;\n		left: 50%;\n		width: 245px;\n		max-height: 155px;\n		transform: translateX(-50%);\n		> li {\n			justify-content: center;\n			padding: 0;\n		}\n	}\n"
    ]);
    LocalCompareGoodsCalendar_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function LocalCompareGoodsCalendar_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: 23px;\n	width: 8px;\n	height: 8px;\n	border-left: 1px solid var(--emp-color);\n	border-bottom: 1px solid var(--emp-color);\n	background-color: transparent;\n\n	&:disabled {\n		border-color: var(--bl-color);\n	}\n\n	",
        "\n"
    ]);
    LocalCompareGoodsCalendar_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function LocalCompareGoodsCalendar_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 245px;\n	table-layout: fixed;\n"
    ]);
    LocalCompareGoodsCalendar_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function LocalCompareGoodsCalendar_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				font-size: var(--basic-size);\n			"
    ]);
    LocalCompareGoodsCalendar_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function LocalCompareGoodsCalendar_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				font-size: 13px;\n			"
    ]);
    LocalCompareGoodsCalendar_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function LocalCompareGoodsCalendar_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	height: 35px;\n	padding: 10px;\n	box-sizing: border-box;\n	border-top: 1px solid var(--line-color);\n	font-size: var(--basic-size);\n	color: var(--emp-color);\n	text-align: center;\n	&:first-child {\n		color: #ff5c46;\n	}\n	&:last-child {\n		color: #4567ad;\n	}\n	",
        "\n"
    ]);
    LocalCompareGoodsCalendar_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function LocalCompareGoodsCalendar_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				> span {\n					font-size: var(--basic-size);\n				}\n				&:hover {\n					> span {\n						border-color: var(--emp-color);\n					}\n				}\n				&:first-child {\n					> span {\n						color: ",
        ";\n					}\n				}\n				&:last-child {\n					> span {\n						color: ",
        ";\n					}\n				}\n			"
    ]);
    LocalCompareGoodsCalendar_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function LocalCompareGoodsCalendar_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n							&:hover {\n								cursor: pointer;\n								> span {\n									border-color: var(--emp-color);\n								}\n							}\n					  "
    ]);
    LocalCompareGoodsCalendar_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function LocalCompareGoodsCalendar_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				&:first-child {\n					> span {\n						color: ",
        ";\n					}\n				}\n				&:last-child {\n					> span {\n						color: ",
        ";\n					}\n				}\n				> span {\n					font-size: 13px;\n				}\n				",
        "\n			"
    ]);
    LocalCompareGoodsCalendar_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function LocalCompareGoodsCalendar_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					background-color: var(--yellow-color);\n					color: var(--emp-color);\n					",
        "\n				"
    ]);
    LocalCompareGoodsCalendar_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function LocalCompareGoodsCalendar_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					background-color: var(--line-color);\n					color: var(--emp-color);\n				"
    ]);
    LocalCompareGoodsCalendar_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function LocalCompareGoodsCalendar_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					background-color: #a4bdf0;\n					color: var(--emp-color);\n				"
    ]);
    LocalCompareGoodsCalendar_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function LocalCompareGoodsCalendar_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	box-sizing: border-box;\n	height: 35px;\n	color: ",
        ";\n	vertical-align: top;\n	text-align: left;\n	cursor: ",
        ";\n\n	",
        "\n	> span {\n		border: 1px solid transparent;\n		border-color: ",
        ";\n		box-sizing: border-box;\n		",
        "\n	}\n"
    ]);
    LocalCompareGoodsCalendar_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function LocalCompareGoodsCalendar_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: center;\n	width: 100%;\n	height: 100%;\n	z-index: 1;\n	color: ",
        ";\n	&:before {\n		position: absolute;\n		top: 0;\n		left: 50%;\n		display: ",
        ';\n		width: 5px;\n		height: 5px;\n		border-radius: 100%;\n		background-color: var(--emp-color);\n		transform: translateX(-50%);\n		content: "";\n	}\n'
    ]);
    LocalCompareGoodsCalendar_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function LocalCompareGoodsCalendar_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	bottom: 0;\n	display: flex;\n	align-items: center;\n	justify-content: center;\n	width: 245px;\n	height: 35px;\n	background: #f7f7f7;\n"
    ]);
    LocalCompareGoodsCalendar_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function LocalCompareGoodsCalendar_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: inline-block;\n	font-size: var(--basic-size);\n	color: var(--emp-color);\n	letter-spacing: -0.07em;\n	&::before {\n		display: inline-block;\n		width: 10px;\n		height: 10px;\n		margin-right: 5px;\n		border-radius: 50%;\n		content: "";\n	}\n	&:nth-child(1)::before {\n		background-color: var(--yellow-color);\n	}\n	&:nth-child(2)::before {\n		background-color: #a4bdf0;\n	}\n	&:nth-child(3)::before {\n		background-color: var(--line-color);\n	}\n	+ li {\n		margin-left: 10px;\n	}\n'
    ]);
    LocalCompareGoodsCalendar_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}






var LocalCompareGoodsCalendar_CalendarWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-376ad58a-0"
})(LocalCompareGoodsCalendar_templateObject2(), function(props) {
    if (props.types === "filter") {
        return (0,styled_components_browser_esm/* css */.iv)(LocalCompareGoodsCalendar_templateObject());
    }
    if (props.types === "basic") {
        return (0,styled_components_browser_esm/* css */.iv)(LocalCompareGoodsCalendar_templateObject1());
    }
});
var LocalCompareGoodsCalendar_CalendarBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-376ad58a-1"
})(LocalCompareGoodsCalendar_templateObject4(), function(props) {
    return props.types === "basic" && (0,styled_components_browser_esm/* css */.iv)(LocalCompareGoodsCalendar_templateObject3());
});
var LocalCompareGoodsCalendar_CalendarMonth = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-376ad58a-2"
})(LocalCompareGoodsCalendar_templateObject5());
var LocalCompareGoodsCalendar_MonthButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-376ad58a-3"
})(LocalCompareGoodsCalendar_templateObject6(), function(props) {
    return props.types === "prev" ? "\n                left: 10px;\n                transform: rotate(45deg);\n            " : "\n                right: 10px;\n                transform: rotate(-135deg);\n            ";
});
var LocalCompareGoodsCalendar_TableCalendar = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-376ad58a-4"
})(LocalCompareGoodsCalendar_templateObject7());
var LocalCompareGoodsCalendar_Month = styled_components_browser_esm/* default.th.withConfig */.ZP.th.withConfig({
    componentId: "sc-376ad58a-5"
})(LocalCompareGoodsCalendar_templateObject10(), function(props) {
    if (props.types === "filter") {
        return (0,styled_components_browser_esm/* css */.iv)(LocalCompareGoodsCalendar_templateObject8());
    }
    if (props.types === "basic") {
        return (0,styled_components_browser_esm/* css */.iv)(LocalCompareGoodsCalendar_templateObject9());
    }
});
var LocalCompareGoodsCalendar_ProductDays = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    componentId: "sc-376ad58a-6"
})(LocalCompareGoodsCalendar_templateObject17(), function(props) {
    return props.isActive ? "var(--emp-color)" : "#aaa";
}, function(props) {
    return props.isActive ? "pointer" : "initial";
}, function(props) {
    if (props.types === "filter") {
        return (0,styled_components_browser_esm/* css */.iv)(LocalCompareGoodsCalendar_templateObject11(), props.isActive ? "var(--red-color)" : "#ffc8c3", props.isActive ? "var(--blue-color)" : "#b5c2de");
    }
    if (props.types === "basic") {
        return (0,styled_components_browser_esm/* css */.iv)(LocalCompareGoodsCalendar_templateObject13(), props.rev ? "var(--red-color)" : "#ffc8c3", props.rev ? "var(--blue-color)" : "#b5c2de", props.rev ? (0,styled_components_browser_esm/* css */.iv)(LocalCompareGoodsCalendar_templateObject12()) : "");
    }
}, function(props) {
    return props.CheckedDay ? "var(--emp-color)" : "transparent";
}, function(props) {
    if (props.types === "basic" && props.rev === "can") {
        return (0,styled_components_browser_esm/* css */.iv)(LocalCompareGoodsCalendar_templateObject14(), props.isActive && "border-color: var(--emp-color)");
    }
    if (props.types === "basic" && props.rev === "end") {
        return (0,styled_components_browser_esm/* css */.iv)(LocalCompareGoodsCalendar_templateObject15());
    }
    if (props.types === "basic" && props.rev === "wait") {
        return (0,styled_components_browser_esm/* css */.iv)(LocalCompareGoodsCalendar_templateObject16());
    }
});
var LocalCompareGoodsCalendar_Day = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-376ad58a-7"
})(LocalCompareGoodsCalendar_templateObject18(), function(props) {
    return props.holiday ? "var(--red-color)" : "";
}, function(props) {
    return props.today ? "block" : "none";
});
var RevList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-376ad58a-8"
})(LocalCompareGoodsCalendar_templateObject19());
var RevListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-376ad58a-9"
})(LocalCompareGoodsCalendar_templateObject20());
var LocalGoodsCompareCalendar = (0,withCalendar/* default */.Z)(function(props, ref) {
    var types = "basic";
    var today = dayjs_min_default()();
    var date = props.date, isNext = props.isNext, isPrevious = props.isPrevious, rangeMonth = props.rangeMonth, // dayList,
    month = props.month, // min,
    // max,
    data = props.data, // clearDate,
    dateChange = props.dateChange, monthChange = props.monthChange, nextMonth = props.nextMonth, prevMonth = props.prevMonth;
    var ref1 = (0,react.useState)(false), showMonth = ref1[0], setShowMonth = ref1[1];
    var id = (0,react.useId)();
    (0,react.useEffect)(function() {
        var event = function(e) {
            if (document.body.contains(e.target)) {
                !e.target.closest("#selectWrap-".concat(CSS.escape(id))) && setShowMonth(false);
                e.target.closest("#options-".concat(CSS.escape(id))) && setShowMonth(false);
            }
        };
        setTimeout(function() {
            return window.addEventListener("click", event);
        });
        return function() {
            window.removeEventListener("click", event);
        };
    }, []);
    var groupByEvStartDt = (0,react.useMemo)(function() {
        var result = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                var evStartDt = item.evStartDt;
                if (!result[evStartDt]) {
                    result[evStartDt] = [];
                }
                result[evStartDt].push(item);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return result;
    }, [
        data
    ]);
    var makeCompareDayList = (0,react.useCallback)(function(referenceDate) {
        var dayCount = referenceDate.date(1).daysInMonth();
        /** 1~7 월~일 */ var startWeekDay = referenceDate.day();
        var endWeekDay = referenceDate.date(dayCount).day();
        var firstWeekEmptyArray = Array(startWeekDay).fill(null);
        var lastWeekEmptyArray = Array(6 - endWeekDay).fill(null);
        var dayArray = Array(dayCount).fill(0).map(function(o, index) {
            var ref;
            var result = {};
            var day = referenceDate.add(index, "day");
            var dayFormat = day.format("YYYYMMDD");
            var groupByItem = Array.isArray(groupByEvStartDt[dayFormat]) && groupByEvStartDt[dayFormat][0];
            var calStatusArray = ((ref = groupByEvStartDt[dayFormat]) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                return item.calStatus;
            })) || [];
            /* A: 예약가능, W: 예약대기, C: 예약마감 */ var calStatus = "";
            if (calStatusArray.includes("A")) {
                calStatus = "can";
            } else if (calStatusArray.includes("W")) {
                calStatus = "wait";
            } else if (calStatusArray.includes("C")) {
                calStatus = "end";
            }
            result = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, groupByItem), {
                day: day,
                calStatus: calStatus
            });
            return result;
        });
        return (0,_to_consumable_array/* default */.Z)(firstWeekEmptyArray).concat((0,_to_consumable_array/* default */.Z)(dayArray), (0,_to_consumable_array/* default */.Z)(lastWeekEmptyArray));
    }, [
        groupByEvStartDt
    ]);
    var compareDayList = (0,react.useMemo)(function() {
        var days = makeCompareDayList(month.date(1));
        return Array.from({
            length: days.length / 7
        }).map(function() {
            return days.splice(0, 7);
        });
    }, [
        month
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalCompareGoodsCalendar_CalendarWrap, {
        id: id,
        types: types,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocalCompareGoodsCalendar_CalendarBox, {
            types: types,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocalCompareGoodsCalendar_CalendarMonth, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_select/* SelectWrap */.vA, {
                            width: 90,
                            id: "selectWrap-".concat(id),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectBox */.jL, {
                                    types: "calendar",
                                    onClick: function() {
                                        return setShowMonth(!showMonth);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectLabel */.n5, {
                                        isActive: true,
                                        children: month.format("YYYY.MM")
                                    })
                                }),
                                showMonth && /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectOptions */.PN, {
                                    id: "options-".concat(id),
                                    children: rangeMonth === null || rangeMonth === void 0 ? void 0 : rangeMonth.map(function(day, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            value: day.format("YYYYMMDD"),
                                            onClick: function(e) {
                                                monthChange(String(e.currentTarget.value));
                                            },
                                            children: day.format("YYYY.MM")
                                        }, index);
                                    })
                                })
                            ]
                        }),
                        isPrevious && /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalCompareGoodsCalendar_MonthButton, {
                            types: "prev",
                            onClick: prevMonth,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "이전달"
                            })
                        }),
                        isNext && /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalCompareGoodsCalendar_MonthButton, {
                            types: "next",
                            onClick: nextMonth,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "다음달"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocalCompareGoodsCalendar_TableCalendar, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalCompareGoodsCalendar_Month, {
                                        types: types,
                                        children: "일"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalCompareGoodsCalendar_Month, {
                                        types: types,
                                        children: "월"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalCompareGoodsCalendar_Month, {
                                        types: types,
                                        children: "화"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalCompareGoodsCalendar_Month, {
                                        types: types,
                                        children: "수"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalCompareGoodsCalendar_Month, {
                                        types: types,
                                        children: "목"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalCompareGoodsCalendar_Month, {
                                        types: types,
                                        children: "금"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalCompareGoodsCalendar_Month, {
                                        types: types,
                                        children: "토"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                            children: compareDayList === null || compareDayList === void 0 ? void 0 : compareDayList.map(function(week, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("tr", {
                                    children: week.map(function(item, weekIdx) {
                                        var day = item === null || item === void 0 ? void 0 : item.day;
                                        // 상품 존재 여부
                                        var isActive = !(day < today.add(-1, "day")) && !!(item === null || item === void 0 ? void 0 : item.calStatus);
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalCompareGoodsCalendar_ProductDays, {
                                            types: types,
                                            onClick: function(e) {
                                                if (isActive) {
                                                    dateChange(day, e);
                                                }
                                            },
                                            rev: (item === null || item === void 0 ? void 0 : item.calStatus) || "",
                                            CheckedDay: date && date.isSame(day),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalCompareGoodsCalendar_Day, {
                                                "data-goods-cd": item === null || item === void 0 ? void 0 : item.goodsCd,
                                                "data-dsp-sid": item === null || item === void 0 ? void 0 : item.dspSid,
                                                "data-date": item === null || item === void 0 ? void 0 : item.evStartDt,
                                                "data-single-type-cd": item === null || item === void 0 ? void 0 : item.singleTypeCd,
                                                types: types,
                                                today: day && today.isSame(day, "day"),
                                                children: day && day.format("DD")
                                            })
                                        }, weekIdx);
                                    })
                                }, index);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(RevList, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RevListItem, {
                            children: "예약가능"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RevListItem, {
                            children: "예약대기"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RevListItem, {
                            children: "예약마감"
                        })
                    ]
                })
            ]
        })
    });
});
/* harmony default export */ var LocalCompareGoodsCalendar = (LocalGoodsCompareCalendar);

;// CONCATENATED MODULE: ./components/style/productlist/compareevent.tsx

function compareevent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	> table {\n		th {\n			height: 50px;\n			padding: 0 10px;\n			text-align: left;\n		}\n		td {\n			height: 50px;\n			padding: 0 10px;\n			text-align: left;\n			vertical-align: top;\n			> div {\n				padding: 15px 0;\n			}\n		}\n		tr {\n			&:first-child {\n				td {\n					vertical-align: middle;\n				}\n			}\n		}\n	}\n"
    ]);
    compareevent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function compareevent_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 16px;\n	color: var(--emp-color);\n	vertical-align: top;\n"
    ]);
    compareevent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function compareevent_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	width: 100%;\n	height: auto;\n	font-size: 16px;\n	text-align: right;\n	vertical-align: middle;\n	color: var(--red-color);\n	em {\n		font-family: "pr-font-medium";\n	}\n'
    ]);
    compareevent_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function compareevent_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	font-family: "pr-font-medium";\n	color: #3094fb;\n'
    ]);
    compareevent_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function compareevent_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: var(--default-color);\n"
    ]);
    compareevent_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function compareevent_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: var(--emp-color);\n"
    ]);
    compareevent_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function compareevent_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	display: flex;\n	align-items: center;\n	height: 50px;\n	padding: 0 10px;\n	margin: 0 -10px;\n	background: var(--disabled-color);\n	border-bottom: 1px solid var(--line-color);\n	color: var(--emp-color);\n	text-align: left;\n	font-size: var(--default-size);\n	font-weight: normal;\n	word-break: keep-all;\n"
    ]);
    compareevent_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function compareevent_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin: 14px 0;\n"
    ]);
    compareevent_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function compareevent_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	+ li {\n		margin-top: 22px;\n	}\n"
    ]);
    compareevent_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function compareevent_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-bottom: 3px;\n	font-size: 15px;\n	color: var(--emp-color);\n"
    ]);
    compareevent_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function compareevent_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 15px;\n	color: var(--default-color);\n"
    ]);
    compareevent_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function compareevent_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	padding-left: 40px;\n	margin-top: 20px;\n	font-size: 20px;\n	font-family: "pr-font-medium";\n	color: var(--emp-color);\n\n	i {\n		position: relative;\n\n		&:before {\n			position: absolute;\n			z-index: 2;\n			top: 1px;\n			left: -31px;\n			display: block;\n			width: 8px;\n			height: 8px;\n			border-radius: 50%;\n			border: 4px solid #3094fb;\n			background-color: #fff;\n			content: "";\n		}\n\n		&:after {\n			position: absolute;\n			z-index: 2;\n			top: 13px;\n			left: -30px;\n			display: block;\n			width: 0;\n			height: 10px;\n			border-left: 7px solid transparent;\n			border-right: 7px solid transparent;\n			border-top: 9px solid #3094fb;\n			transform-origin: 0 100%;\n			content: "";\n		}\n	}\n\n	span {\n		padding-left: 20px;\n	}\n'
    ]);
    compareevent_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function compareevent_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	padding-left: 40px;\n	margin-top: 15px;\n\n	&:before {\n		position: absolute;\n		top: 5px;\n		left: 9px;\n		z-index: 1;\n		display: block;\n		width: 6px;\n		height: 6px;\n		border-radius: 50%;\n		border: 5px solid #daecfe;\n		background-color: #3094fb;\n		content: "";\n	}\n'
    ]);
    compareevent_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function compareevent_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin: 14px 0;\n"
    ]);
    compareevent_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function compareevent_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	justify-content: space-between;\n	+ li {\n		margin-top: 4px;\n	}\n"
    ]);
    compareevent_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function compareevent_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	flex: 1 1 auto;\n"
    ]);
    compareevent_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function compareevent_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	flex: 0 0 100px;\n	text-align: right;\n	color: var(--blue-color);\n"
    ]);
    compareevent_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function compareevent_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: center;\n"
    ]);
    compareevent_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}

var compareevent_TableWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef8ae8e2-0"
})(compareevent_templateObject());
var compareevent_ProductExplain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef8ae8e2-1"
})(compareevent_templateObject1());
var compareevent_ProductPrice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef8ae8e2-2"
})(compareevent_templateObject2());
var AirplaneNumber = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-ef8ae8e2-3"
})(compareevent_templateObject3());
var AirplaneDepart = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-ef8ae8e2-4"
})(compareevent_templateObject4());
var AirplaneDay = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-ef8ae8e2-5"
})(compareevent_templateObject5());
var ScheduleTitle = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    componentId: "sc-ef8ae8e2-6"
})(compareevent_templateObject6());
var ScheduleList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-ef8ae8e2-7"
})(compareevent_templateObject7());
var ScheduleListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-ef8ae8e2-8"
})(compareevent_templateObject8());
var ScheduleSubTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-ef8ae8e2-9"
})(compareevent_templateObject9());
var ScheduleText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-ef8ae8e2-10"
})(compareevent_templateObject10());
var LocationTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-ef8ae8e2-11"
})(compareevent_templateObject11());
var LocationText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-ef8ae8e2-12"
})(compareevent_templateObject12());
var TourList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-ef8ae8e2-13"
})(compareevent_templateObject13());
var TourListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-ef8ae8e2-14"
})(compareevent_templateObject14());
var TourName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-ef8ae8e2-15"
})(compareevent_templateObject15());
var TourPrice = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-ef8ae8e2-16"
})(compareevent_templateObject16());
var compareevent_BtnBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef8ae8e2-17"
})(compareevent_templateObject17());


// EXTERNAL MODULE: ./components/common/eventUtil.ts
var eventUtil = __webpack_require__(99346);
;// CONCATENATED MODULE: ./components/product/pages/localList/desktop/popup/CompareEventPopup.tsx















var CompareEventPopupComponent = function(props) {
    var router = (0,next_router.useRouter)();
    var compareList = props.compareList, compareScheduleList = props.compareScheduleList, compareSelTripList = props.compareSelTripList, overlayProps = (0,_object_without_properties/* default */.Z)(props, [
        "compareList",
        "compareScheduleList",
        "compareSelTripList"
    ]);
    var Colgroup = (0,react.useMemo)(function() {
        if (compareList && compareList.length === 2) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        style: {
                            width: "8%"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        style: {
                            width: "8%"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        style: {
                            width: "42%"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        style: {
                            width: "42%"
                        }
                    })
                ]
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        style: {
                            width: "9%"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        style: {
                            width: "7%"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        style: {
                            width: "28%"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        style: {
                            width: "28%"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        style: {
                            width: "28%"
                        }
                    })
                ]
            });
        }
    }, [
        compareList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popup/* PopupContainer */.k, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, overlayProps), {
        title: "비교하기",
        size: "large",
        paddingTop: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(compareevent_TableWrap, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* TableContainer */.x, {
                lineTop: false,
                types: "vertical",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                        children: "행사 비교"
                    }),
                    Colgroup,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        colSpan: 2,
                                        children: "상품번호"
                                    }),
                                    compareList.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: item.evCd
                                        }, index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        colSpan: 2,
                                        children: "상품명"
                                    }),
                                    compareList.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(compareevent_ProductExplain, {
                                                children: item.evNm
                                            })
                                        }, index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        rowSpan: 3,
                                        children: "상품가"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        children: "성인"
                                    }),
                                    compareList.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(compareevent_ProductPrice, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                        children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(item.adtPrice)
                                                    }),
                                                    " 원"
                                                ]
                                            })
                                        }, index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        children: "아동"
                                    }),
                                    compareList.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(compareevent_ProductPrice, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                        children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(item.chdPrice)
                                                    }),
                                                    " 원"
                                                ]
                                            })
                                        }, index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        children: "유아"
                                    }),
                                    compareList.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(compareevent_ProductPrice, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                        children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(item.infPrice)
                                                    }),
                                                    " 원"
                                                ]
                                            })
                                        }, index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        colSpan: 2,
                                        children: "여행 기간"
                                    }),
                                    compareList.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: item.evNightNm
                                            })
                                        }, index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        rowSpan: 3,
                                        colSpan: 2,
                                        children: "일정"
                                    }),
                                    compareList.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                                gap: "10",
                                                align: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: (0,eventUtil/* getTrafficIconUrl */.wz)({
                                                            trTp: item.trTp,
                                                            trCompanySnm: item.outAirCd
                                                        }),
                                                        alt: item.outAirCompany
                                                    }),
                                                    item.outAirCompany
                                                ]
                                            })
                                        }, index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                children: compareList.map(function(item, index) {
                                    var goodsAreaOne = item.evCd.substring(0, 1);
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                            gap: "5",
                                            align: "center",
                                            wrap: "wrap",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AirplaneDepart, {
                                                    children: [
                                                        goodsAreaOne !== "K" && "한국" || "",
                                                        "출발"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AirplaneNumber, {
                                                    children: item.outFlightNm
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AirplaneDay, {
                                                    children: (0,eventUtil/* departureStart */.jn)(item)
                                                })
                                            ]
                                        })
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                children: compareList.map(function(item, index) {
                                    var goodsAreaOne = item.evCd.substring(0, 1);
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                            gap: "5",
                                            align: "center",
                                            wrap: "wrap",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AirplaneDepart, {
                                                    children: [
                                                        goodsAreaOne !== "K" && "한국" || "",
                                                        "도착"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AirplaneNumber, {
                                                    children: item.inFlightNm
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AirplaneDay, {
                                                    children: (0,eventUtil/* returnArrival */.jp)({
                                                        evArriveDt: item.inArriveDt,
                                                        inArrvTm: item.inArrvTm
                                                    })
                                                })
                                            ]
                                        })
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        colSpan: 2,
                                        children: "방문 도시"
                                    }),
                                    compareList.map(function(item, index) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: item === null || item === void 0 ? void 0 : item.goodsTourInfo
                                            })
                                        }, index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        colSpan: 2,
                                        children: "숙박"
                                    }),
                                    compareList.map(function(item, index) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: item === null || item === void 0 ? void 0 : item.accomNm
                                            })
                                        }, index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        colSpan: 2,
                                        children: "포함 사항"
                                    }),
                                    compareScheduleList.map(function(item, index) {
                                        var ref;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorBox */.M, {
                                                dangerouslySetInnerHTML: {
                                                    __html: (item === null || item === void 0 ? void 0 : (ref = item.inclInfo) === null || ref === void 0 ? void 0 : ref.replace(/\r\n/g, "<br/>")) || ""
                                                }
                                            })
                                        }, index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        colSpan: 2,
                                        children: "불포함 사항"
                                    }),
                                    compareScheduleList.map(function(item, index) {
                                        var ref;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorBox */.M, {
                                                dangerouslySetInnerHTML: {
                                                    __html: item === null || item === void 0 ? void 0 : (ref = item.notinclInfo) === null || ref === void 0 ? void 0 : ref.replace(/\r\n/g, "<br/>")
                                                }
                                            })
                                        }, index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        colSpan: 2,
                                        children: "참고/전달사항"
                                    }),
                                    compareScheduleList.map(function(item, index) {
                                        var ref;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorBox */.M, {
                                                dangerouslySetInnerHTML: {
                                                    __html: item === null || item === void 0 ? void 0 : (ref = item.refeInfo) === null || ref === void 0 ? void 0 : ref.replace(/\r\n/g, "<br/>")
                                                }
                                            })
                                        }, index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        colSpan: 2,
                                        children: "선택관광"
                                    }),
                                    compareSelTripList === null || compareSelTripList === void 0 ? void 0 : compareSelTripList.map(function(compareSelTrip, tripIndex) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TourList, {
                                                children: compareSelTrip === null || compareSelTrip === void 0 ? void 0 : compareSelTrip.map(function(item, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TourListItem, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TourName, {
                                                                children: item.title
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TourPrice, {
                                                                children: item.cost
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            })
                                        }, tripIndex);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        colSpan: 2,
                                        children: "쇼핑"
                                    }),
                                    compareList.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    item.shopCnt,
                                                    "회"
                                                ]
                                            })
                                        }, index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        colSpan: 2
                                    }),
                                    compareList.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(compareevent_BtnBlock, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* TextButton */.Av, {
                                                    text: "상품 상세보기",
                                                    size: "default",
                                                    types: "basic",
                                                    onClick: function() {
                                                        // 링크 확인 필요
                                                        router.push(item.webLinkUrl.replace(".yb", "") || "#");
                                                        overlayProps.close();
                                                    }
                                                })
                                            })
                                        }, index);
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    }));
};
var CompareEventPopup = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "CompareEventPopup Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareEventPopupComponent, (0,src_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var popup_CompareEventPopup = (CompareEventPopup);

;// CONCATENATED MODULE: ./components/product/pages/localList/desktop/popup/CompareProductsPopup.tsx






















var CompareProductsPopupComponent = function(props) {
    var compareList = props.compareList, calendarList = props.calendarList, overlayProps = (0,_object_without_properties/* default */.Z)(props, [
        "compareList",
        "calendarList"
    ]);
    var ref = (0,react.useState)([]), eventCompare = ref[0], setEventCompare = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref1[0];
    var onDateChange = function(e) {
        var _dataset = e.target.dataset, goodsCd = _dataset.goodsCd, dspSid = _dataset.dspSid, date = _dataset.date, singleTypeCd = _dataset.singleTypeCd;
        if (!goodsCd) return;
        var existingIndex = eventCompare === null || eventCompare === void 0 ? void 0 : eventCompare.findIndex(function(v) {
            return v.compareGoodsCd === goodsCd;
        });
        if (existingIndex !== -1) {
            setEventCompare(function(prevEventCompare) {
                var updatedEventCompare = (0,_to_consumable_array/* default */.Z)(prevEventCompare);
                var existingData = updatedEventCompare[existingIndex];
                // 다른 데이터 수정
                if (dspSid) existingData.compareDspSid = dspSid;
                if (date) existingData.compareDate = date;
                if (singleTypeCd) existingData.compareSingleTypeCd = singleTypeCd;
                return updatedEventCompare;
            });
        } else {
            // 추가
            setEventCompare(function(prevEventCompare) {
                return (0,_to_consumable_array/* default */.Z)(prevEventCompare).concat([
                    {
                        compareGoodsCd: goodsCd,
                        compareDspSid: dspSid || "",
                        compareDate: date || "",
                        compareSingleTypeCd: singleTypeCd || ""
                    }, 
                ]);
            });
        }
    };
    // 출발일 기준 상품 비교하기
    var handleClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var compareGoodsCd, compareDspSid, compareDate, compareSingleTypeCd, obj, _tmp, result, body;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (compareList.length !== eventCompare.length) {
                            open(function(prop) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prop), {
                                    text: "출발일을 모두 선택해주세요."
                                }));
                            });
                            return [
                                2,
                                false
                            ];
                        }
                        compareGoodsCd = eventCompare.map(function(item) {
                            return item.compareGoodsCd;
                        }).join(",");
                        compareDspSid = eventCompare.map(function(item) {
                            return item.compareDspSid;
                        }).join(",");
                        compareDate = eventCompare.map(function(item) {
                            return item.compareDate;
                        }).join(",");
                        compareSingleTypeCd = eventCompare.map(function(item) {
                            return item.compareSingleTypeCd;
                        }).join(",");
                        _tmp = {};
                        obj = (_tmp.compareGoodsCd = compareGoodsCd, _tmp.compareDspSid = compareDspSid, _tmp.compareDate = compareDate, _tmp.compareSingleTypeCd = compareSingleTypeCd, _tmp);
                        return [
                            4,
                            eventCompareAsync(obj)
                        ];
                    case 1:
                        result = _state.sent();
                        body = result.data.body;
                        if (body) {
                            overlayProps.close();
                            open(function(prop) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(popup_CompareEventPopup, (0,src_object_spread/* default */.Z)({}, prop, body));
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var getCalData = (0,react.useMemo)(function() {
        var result = {};
        compareList.forEach(function(item) {
            var cal = calendarList.filter(function(v) {
                return v.goodsCd === item.goodsCd;
            });
            result[item.goodsCd] = cal;
        });
        return result;
    }, [
        calendarList
    ]);
    var Colgroup = (0,react.useMemo)(function() {
        if (compareList && compareList.length === 2) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        style: {
                            width: "8%"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        style: {
                            width: "8%"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        style: {
                            width: "42%"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        style: {
                            width: "42%"
                        }
                    })
                ]
            });
        } else if (compareList && compareList.length === 3) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        style: {
                            width: "9%"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        style: {
                            width: "7%"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        style: {
                            width: "28%"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        style: {
                            width: "28%"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                        style: {
                            width: "28%"
                        }
                    })
                ]
            });
        }
    }, [
        compareList
    ]);
    (0,useTagging/* useTaggingLoad */.q)("pkg_compare_goodsCd", compareList);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: compareList && /*#__PURE__*/ (0,jsx_runtime.jsxs)(popup/* PopupContainer */.k, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, overlayProps), {
            title: "비교하기",
            size: "large",
            paddingTop: false,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableWrap, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* TableContainer */.x, {
                        lineTop: false,
                        types: "vertical",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                                children: "상품 비교"
                            }),
                            Colgroup,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                scope: "row",
                                                colSpan: 2,
                                                children: "상품번호"
                                            }),
                                            compareList.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: item.goodsCd
                                                }, index);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                scope: "row",
                                                colSpan: 2,
                                                children: "상품명"
                                            }),
                                            compareList.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductExplain, {
                                                        children: item.goodsNm
                                                    })
                                                }, index);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                scope: "row",
                                                rowSpan: 3,
                                                children: "상품가"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                scope: "row",
                                                children: "성인"
                                            }),
                                            compareList.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductPrice, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                                children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(item.minAdtPrice)
                                                            }),
                                                            " 원 ~",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                                children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(item.maxAdtPrice)
                                                            }),
                                                            " 원"
                                                        ]
                                                    })
                                                }, index);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                scope: "row",
                                                children: "아동"
                                            }),
                                            compareList.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductPrice, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                                children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(item.minChdPrice)
                                                            }),
                                                            " 원 ~",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                                children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(item.maxChdPrice)
                                                            }),
                                                            " 원"
                                                        ]
                                                    })
                                                }, index);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                scope: "row",
                                                children: "유아"
                                            }),
                                            compareList.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductPrice, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                                children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(item.minInfPrice)
                                                            }),
                                                            " 원 ~",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                                children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(item.maxInfPrice)
                                                            }),
                                                            " 원"
                                                        ]
                                                    })
                                                }, index);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                scope: "row",
                                                colSpan: 2,
                                                children: "여행 기간"
                                            }),
                                            compareList.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: item.evNightNm
                                                    })
                                                }, index);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                scope: "row",
                                                colSpan: 2,
                                                children: "방문 도시"
                                            }),
                                            compareList.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: item.vcityInfo
                                                    })
                                                }, index);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                scope: "row",
                                                colSpan: 2,
                                                children: "여행포인트"
                                            }),
                                            compareList.map(function(item, index) {
                                                var ref;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorBox */.M, {
                                                        dangerouslySetInnerHTML: {
                                                            __html: (ref = item.prdExpl) === null || ref === void 0 ? void 0 : ref.replace(/\r\n/g, "<br/>")
                                                        }
                                                    })
                                                }, index);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                scope: "row",
                                                colSpan: 2,
                                                children: "출발일 선택"
                                            }),
                                            compareList.map(function(item, index) {
                                                var cal = getCalData[item.goodsCd];
                                                if (!cal || cal.length === 0) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                                                var copyCal = (0,_to_consumable_array/* default */.Z)(cal);
                                                var min = copyCal.length < 2 ? copyCal[0].evStartDt : copyCal.shift().evStartDt;
                                                var max = copyCal.length < 2 ? copyCal[0].evStartDt : copyCal.pop().evStartDt;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalCompareGoodsCalendar, {
                                                        minDate: min,
                                                        maxDate: max,
                                                        data: cal,
                                                        onDateChange: function(date, e) {
                                                            return onDateChange(e);
                                                        }
                                                    })
                                                }, index);
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BtnBlock, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* TextButton */.Av, {
                        text: "출발일 기준 상품 비교하기",
                        types: "confirm",
                        onClick: handleClick
                    })
                })
            ]
        }))
    });
};
var CompareProductsPopup = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "CompareProductsPopup Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareProductsPopupComponent, (0,src_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var popup_CompareProductsPopup = (CompareProductsPopup);

// EXTERNAL MODULE: ./components/common/flag/Desktop.tsx
var flag_Desktop = __webpack_require__(76031);
// EXTERNAL MODULE: ./components/common/goodsUtil.ts
var goodsUtil = __webpack_require__(68284);
// EXTERNAL MODULE: ./components/common/modal/share/Desktop.tsx + 3 modules
var share_Desktop = __webpack_require__(90451);
// EXTERNAL MODULE: ./framework/ui/desktop/flag/index.ts
var flag = __webpack_require__(34869);
// EXTERNAL MODULE: ./framework/ui/desktop/icon/AirlineIcon.tsx
var AirlineIcon = __webpack_require__(38502);
// EXTERNAL MODULE: ./framework/ui/desktop/thumbnail/ProductListThumbnail.tsx
var ProductListThumbnail = __webpack_require__(84162);
// EXTERNAL MODULE: ./node_modules/@yb/ui/desktop/common/Flag/index.cjs
var Flag = __webpack_require__(29621);
// EXTERNAL MODULE: ./node_modules/@yb/ui/desktop/common/Noimage/index.cjs
var Noimage = __webpack_require__(78860);
;// CONCATENATED MODULE: ./components/product/pages/localList/desktop/goods/LocalGoods.tsx





























var HashTagDescription = function(props) {
    if (!props.keyWordList) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* Hashtag */.AQ, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: (0,goodsUtil/* hashTagManufacture */.Cx)(props.keyWordList, 3)
        })
    });
};
var TagSquareDescription = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlist/* TagSquareWrap */.N$, {
            gap: "5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(flag_Desktop/* FlagGoodsCd */.G, {
                    goodsCd: props.goodsCd
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(flag_Desktop/* FlagGoodsTp */.B2, {
                    goodsTp: props.goodsTp
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(flag_Desktop/* FlagGoodsBrandCd */.hA, {
                    goodsBrandCd: props.goodsBrandCd
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(flag_Desktop/* FlagGoodsTmember */.$4, {
                    goodsTmember: props.goodsTmember
                })
            ]
        })
    });
};
var InfoGroupDescription = function(props) {
    var ref;
    var goodsFeaturesList = props.goodsFeaturesList, goodsTpointContents = props.goodsTpointContents;
    if (!goodsFeaturesList && !goodsTpointContents) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var ref1 = (0,react.useState)(false), isShow = ref1[0], setIsShow = ref1[1];
    var benefitToggle = function(e) {
        setIsShow(true);
        e.preventDefault();
    };
    var goodsFeatureString = goodsFeaturesList === null || goodsFeaturesList === void 0 ? void 0 : goodsFeaturesList.split("|").map(function(v) {
        return v.split(",")[0];
    }).join(", ").toString();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* InfoGroup */.aJ, {
        direction: "column",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlist/* InfoGroupContent */.VJ, {
            show: isShow,
            children: [
                goodsFeatureString && /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                    children: goodsFeatureString
                }),
                goodsTpointContents && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: goodsTpointContents.replace(/\n/g, "<br>")
                    }
                }),
                goodsTpointContents && ((ref = goodsTpointContents.match(/\n/g)) === null || ref === void 0 ? void 0 : ref.length) > 2 && !isShow && /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* BenefitButton */.Xk, {
                    type: "button",
                    onClick: benefitToggle,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "더보기"
                    })
                })
            ]
        })
    });
};
var StartFixDateDescription = function(props) {
    if (!props.startFixOpenDtList) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var formatDateList = props.startFixOpenDtList.split(",").map(function(date) {
        return dayjs_min_default()(date).format("MM.DD");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                children: "출발확정"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: formatDateList.slice(0, 10).join(" / ")
                })
            })
        ]
    });
};
var StartEndDateDescription = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                    children: "출발기간"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                    children: "".concat(dayjs_min_default()(props.minStartDt).format("YYYY.MM.DD"), " ~ ").concat(dayjs_min_default()(props.maxStartDt).format("YYYY.MM.DD"))
                })
            ]
        })
    });
};
var StartWeekDayDescription = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                children: "출발요일"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,goodsUtil/* StartWeek */.xN)(props)
                })
            })
        ]
    });
};
var AirDescription = function(props) {
    if (!props.airCd) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var companyList = (0,goodsUtil/* airOrderSort */.Y$)(props);
    var trArray = companyList.slice(0, 4);
    var otherCdCnt = companyList.length - 4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                children: "이용교통"
            }),
            trArray.map(function(trString, index) {
                var trInfoArray = trString.split(",");
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AirlineIcon/* default */.Z, {
                        img: "".concat(config_public/* default.ENV_STATIC_CDN_URL */.Z.ENV_STATIC_CDN_URL, "/images/air/").concat(trInfoArray[1], ".png"),
                        title: trInfoArray[0]
                    })
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                children: otherCdCnt > 0 && " 외 ".concat(otherCdCnt)
            })
        ]
    });
};
var PriceDescription = function(props) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlist/* PriceTag */.WR, {
                    children: [
                        props.goodsPromotion && /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* PromotionFlag */.kN, {
                            children: props.goodsPromotion.split(",")[1]
                        }),
                        props.couponYn === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flag/* Flag */.W, {
                            $type: "promotion",
                            $flag: "coupon",
                            text: "쿠폰할인"
                        })
                    ]
                }),
                (props === null || props === void 0 ? void 0 : props.ypdYn) === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlist/* RegularPrice */.IN, {
                        children: [
                            ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(props.ypdPrice),
                            "원"
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlist/* DiscountPrice */.oP, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(props.minPrice)
                        }),
                        " 원~"
                    ]
                })
            ]
        })
    });
};
var LocalGoodsComponent = function(props) {
    var ref, ref1, ref2;
    var product = props.product, checkedArray = props.checkedArray, handleChecked = props.handleChecked, handleCompare = props.handleCompare;
    var goodsCd = product.goodsCd;
    var router = (0,next_router.useRouter)();
    var dspSid = "".concat((ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.dspSid) === null || ref1 === void 0 ? void 0 : ref1.slice(0, -2), "00");
    var menu = (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.menu;
    var isChecked = checkedArray.includes(goodsCd);
    var lastChecked = checkedArray[checkedArray.length - 1];
    // 공유하기
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref3[0];
    var handleShare = function() {
        open(function(prop) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(share_Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prop), {
                parameter: "menu=".concat(menu, "&dspSid=").concat(dspSid, "&goodsCd=").concat(goodsCd)
            }));
        });
    };
    // 출발일 보기
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)("slideIn"), 1), slide = ref4[0];
    var handleEventList = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var result, body;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,useGoodsOneAvailEvent/* goodsAvailEventAsync */.iS)(goodsCd)
                        ];
                    case 1:
                        result = _state.sent();
                        body = result.data.body;
                        slide(function(prop) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListPopup/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prop), {
                                goodsCd: goodsCd,
                                availEvent: body
                            }));
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function handleEventList(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("pkg_select_prod_list", {
        goodsCd: goodsCd
    }).taggingClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* ProcutList */.Ft, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlist/* ProcutListItem */.Si, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlist/* ProcutItemLink */.vp, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductListThumbnail/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* Checkboxbox */.o9, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Checkbox */.XZ, {
                                            id: "check",
                                            onChange: handleChecked,
                                            checked: isChecked,
                                            bg: "yellow",
                                            value: goodsCd
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlist/* PromotionBox */.NZ, {
                                        children: [
                                            product.ypdYn === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flag/* Flag */.W, {
                                                $type: "promotion",
                                                $flag: "yellowpangdeal",
                                                text: "옐로팡딜"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(flag_Desktop/* FlagPromotion */.tI, {
                                                goodsCd: goodsCd
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlist/* ImageBox */.FS, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Noimage/* Noimage */.T, {
                                                src: product.imageThum3,
                                                alt: "",
                                                width: "275px",
                                                height: "185px"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HashTagDescription, (0,src_object_spread/* default */.Z)({}, product))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                direction: "column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                        justify: "space-between",
                                        align: "start",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TagSquareDescription, (0,src_object_spread/* default */.Z)({}, product)),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(list/* StackList */.fe, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* StackListItem */.jS, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlist/* Review */.Cq, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(flag/* StarIcon */.r7, {}),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* Grade */.GR, {
                                                                    children: product.rvwAvgScore || "-"
                                                                }),
                                                                "\xa0/ 5"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* StackListItem */.jS, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* IconButton */.hU, {
                                                            icon: "share",
                                                            onClick: handleShare,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "공유하기"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* Name */.VG, {
                                        children: product.goodsNm
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoGroupDescription, (0,src_object_spread/* default */.Z)({}, product)),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlist/* Summary */.ER, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StartFixDateDescription, (0,src_object_spread/* default */.Z)({}, product)),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                                gap: "10",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StartEndDateDescription, (0,src_object_spread/* default */.Z)({}, product)),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* SummaryDays */.Ig, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StartWeekDayDescription, (0,src_object_spread/* default */.Z)({}, product))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AirDescription, (0,src_object_spread/* default */.Z)({}, product))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* PriceBox */.bz, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceDescription, (0,src_object_spread/* default */.Z)({}, product))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* ProductListItemData */.rd, {
                        onClick: function(e) {
                            handleEventList(e);
                            taggingClick();
                        }
                    }),
                    lastChecked === goodsCd && checkedArray.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* CompareButtonBox */.kA, {
                        onClick: handleCompare
                    }),
                    isChecked && (lastChecked !== goodsCd || checkedArray.length === 1) && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* CompareTextBox */.y8, {})
                ]
            })
        })
    });
};
var LocalGoods = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "Product Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalGoodsComponent, (0,src_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var goods_LocalGoods = (LocalGoods);

;// CONCATENATED MODULE: ./components/product/pages/localList/desktop/goods/LocalGoodsList.tsx


























var LocalGoodsListComponent = function() {
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var dspSid = (ref = router.query) === null || ref === void 0 ? void 0 : ref.dspSid;
    // const [showViewBraze, setShowViewBraze] = useState(true);
    var ref3 = (0,filterHook/* default */.Z)(), getFilter = ref3.getFilter, getFilteringProduct = ref3.getFilteringProduct;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref4[0];
    var openAlert = function(text, afterFunc) {
        open(function(prop) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prop), {
                text: text,
                afterClose: afterFunc,
                afterConfirm: afterFunc
            }));
        });
    };
    var goodsListFetch = (0,useGoodsByMenu/* default */.Z)(dspSid);
    var goodsList = getFilteringProduct();
    var ref5 = (0,react.useState)([]), checkedArray = ref5[0], setCheckedArray = ref5[1];
    // 선택상품 비교
    var handleCompare = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var result, data, body, calendarList, compareList;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (checkedArray.length < 2 || checkedArray.length > 3) {
                            openAlert("상품비교를 위해서는 상품을<br/>2개 이상 3개 이하로 선택하셔야 합니다.");
                            return [
                                2,
                                false
                            ];
                        }
                        return [
                            4,
                            (0,useGoodsCompare/* goodsCompareAsync */.kC)(String(checkedArray))
                        ];
                    case 1:
                        result = _state.sent();
                        data = result.data;
                        body = data.body;
                        if (body) {
                            calendarList = body.calendarList;
                            compareList = body.compareList;
                            open(function(props) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(popup_CompareProductsPopup, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                                    calendarList: calendarList,
                                    compareList: compareList
                                }));
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCompare() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChecked = function(e) {
        var _target = e.target, value = _target.value, checked = _target.checked;
        var isChecked = checkedArray.includes(value);
        if (checkedArray.length >= 3 && !isChecked) {
            openAlert("비교상품은 총 3개까지 선택이 가능합니다.");
            return;
        }
        if (checkedArray.length < 3 || isChecked) {
            if (checked) {
                setCheckedArray((0,_to_consumable_array/* default */.Z)(checkedArray).concat([
                    value
                ]));
            } else {
                setCheckedArray(checkedArray.filter(function(v) {
                    return v !== value;
                }));
            }
        }
    };
    (0,react.useEffect)(function() {
        setCheckedArray([]); // 필터 변경시 상품비교 초기화
    }, [
        getFilter()
    ]);
    var routerGoodsCd = (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.goodsCd;
    var routerGoodsMonth = (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.goodsMonth;
    var ref6 = (0,react.useState)(true), isEvent = ref6[0], setIsEvent = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)("slideIn"), 1), slide = ref7[0];
    (0,react.useEffect)(function() {
        if (isEvent && routerGoodsCd && goodsList.length > 0) {
            var handleEventList = function(goodsCd, availEvent) {
                setIsEvent(false);
                var productItem = goodsList.find(function(v) {
                    return v.goodsCd === goodsCd;
                });
                productItem && slide(function(props) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(EventListPopup/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                        availEvent: availEvent,
                        goodsCd: productItem === null || productItem === void 0 ? void 0 : productItem.goodsCd
                    }));
                });
            };
            (0,_async_to_generator/* default */.Z)(function() {
                var result, data, body;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,useGoodsOneAvailEvent/* goodsAvailEventAsync */.iS)(routerGoodsCd)
                            ];
                        case 1:
                            result = _state.sent();
                            data = result.data;
                            body = data.body;
                            if (routerGoodsMonth && dayjs_min_default()(routerGoodsMonth).isValid()) body.evStartDt = routerGoodsMonth;
                            body.evCd && handleEventList(body.evCd.substring(0, 7), body);
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    }, [
        routerGoodsCd,
        routerGoodsMonth,
        goodsList
    ]);
    var renderGoodsList = function() {
        if (goodsListFetch.isFetching) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_LoadingBox, {})
            });
        }
        if (goodsList.length === 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* WarningBox */.Xr, {
                children: "해당하는 상품이 존재하지 않습니다."
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: goodsList.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(goods_LocalGoods, {
                    product: item,
                    checkedArray: checkedArray,
                    handleChecked: handleChecked,
                    handleCompare: handleCompare
                }, item.goodsCd);
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* ProcutContentWrap */.Gv, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlist/* ProcutContentWrap */.Gv, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_filter/* RatingHeader */.mE, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* TextButton */.Av, {
                            text: "선택상품 비교",
                            size: "default",
                            onClick: handleCompare
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_LocalSortFilter, {})
                    ]
                }),
                renderGoodsList()
            ]
        })
    });
};
var LocalGoodsList = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "ProductArea Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalGoodsListComponent, {})
    });
};
/* harmony default export */ var goods_LocalGoodsList = (LocalGoodsList);

// EXTERNAL MODULE: ./framework/ui/desktop/text/index.ts + 2 modules
var desktop_text = __webpack_require__(81499);
// EXTERNAL MODULE: ./hooks/services/queries/bff/global/useGlobalGoodsFlag.ts
var useGlobalGoodsFlag = __webpack_require__(64630);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/goods/useGoodsFilter.ts
var useGoodsFilter = __webpack_require__(85961);
// EXTERNAL MODULE: ./store/index.ts + 2 modules
var store = __webpack_require__(79390);
// EXTERNAL MODULE: ./store/store-filter.ts
var store_filter = __webpack_require__(57467);
;// CONCATENATED MODULE: ./pages/product/localList.page.tsx























var Page = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var router = (0,next_router.useRouter)();
    var dspSid = (ref = router.query) === null || ref === void 0 ? void 0 : ref.dspSid;
    // goodsFlag 미리 호출 (FlagPromotion 에서 사용)
    (0,useGlobalGoodsFlag/* default */.Z)();
    var ref6 = (0,filterHook/* default */.Z)(), getFilter = ref6.getFilter, getFilteringProduct = ref6.getFilteringProduct;
    var filterFetch = (0,useGoodsFilter/* default */.ZP)(dspSid);
    var filter = (ref1 = filterFetch.data) === null || ref1 === void 0 ? void 0 : ref1.body;
    var productList = getFilteringProduct();
    /* filterStore 초기화 */ var filterStore = (0,store/* useAppSelector */.CG)(function(state) {
        return state.goodsFilterStore;
    });
    var dispatch = (0,store/* useAppDispatch */.TL)();
    (0,react.useEffect)(function() {
        var storeDspSid = filterStore.goodsFilter ? Object.keys(filterStore === null || filterStore === void 0 ? void 0 : filterStore.goodsFilter)[0] : {};
        if (dspSid && dspSid !== storeDspSid) {
            var storeInit = (0,_define_property/* default */.Z)({}, dspSid, [
                {
                    text: "추천순",
                    value: "sortOrder",
                    key: "sort",
                    asc: true
                }
            ]);
            dispatch((0,store_filter/* initGoodsFilter */.yj)()); /* 데이터 초기화*/ 
            dispatch((0,store_filter/* setGoodsFilter */.Hv)(storeInit)); /* dspSid 세팅 */ 
        }
    }, [
        router
    ]);
    // 필터 영역 로우 체크
    var filteredCount = (ref2 = getFilter()) === null || ref2 === void 0 ? void 0 : ref2.filter(function(v) {
        return v.key !== "sort" && v.key !== "dspSid";
    }).length;
    // header 높이값
    var fixedTitle = (0,react.useRef)(null); // 타이틀 header
    var fixedHeader = (0,react.useRef)(null); // 필터 header
    var ref7 = (0,react.useState)(null), fixedHeaderHeight = ref7[0], setFixedHeaderHeight = ref7[1];
    (0,react.useEffect)(function() {
        // fixed header 크기 조절 감지
        var fixedHeaderElement = fixedHeader === null || fixedHeader === void 0 ? void 0 : fixedHeader.current;
        var fixedTitleHeader = fixedTitle === null || fixedTitle === void 0 ? void 0 : fixedTitle.current;
        if (!fixedHeaderElement) return;
        var observer = new ResizeObserver(function() {
            setFixedHeaderHeight(fixedHeaderElement.clientHeight + fixedTitleHeader.clientHeight);
        });
        observer.observe(fixedHeaderElement);
        return function() {
            observer.disconnect();
        };
    }, [
        filter,
        filteredCount
    ]);
    var productCount = productList.length || 0; // 상품 갯수
    /** tagging load */ (0,useTagging/* useTaggingLoad */.q)("pkg_view_goodsCdList");
    var ref8;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_Desktop/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_filter/* FloatingContent */.wf, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Container */.W2, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlist/* ContentWrap */.Xs, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlist/* ContentHeader */.yW, {
                                    ref: fixedTitle,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* Title */.Dx, {
                                            children: filter && filter.dspNm
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "상품",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* Count */.XF, {
                                                    children: productCount
                                                }),
                                                "개"
                                            ]
                                        })
                                    ]
                                }),
                                filter && /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalLvl4List, (0,src_object_spread/* default */.Z)({}, filter)),
                                filteredCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(productlist/* FilterHeaderWrap */.H7, {
                                    ref: fixedHeader,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalHeadArea, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlist/* Content */.VY, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_filter/* FloatingWrap */.tX, {
                                                style: {
                                                    top: filteredCount > 0 ? "".concat(fixedHeaderHeight, "px") : "72px"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_LocalSideFilter, (0,src_object_spread/* default */.Z)({}, filter))
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(goods_LocalGoodsList, {})
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* default */.Z, {}),
            ((ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.goodsCd) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GTMTags/* default */.Z, {
                    menu: (ref8 = (ref4 = router.query) === null || ref4 === void 0 ? void 0 : ref4.menu) !== null && ref8 !== void 0 ? ref8 : "",
                    goodsCd: (ref5 = router.query) === null || ref5 === void 0 ? void 0 : ref5.goodsCd
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var localList_page = (Page);


/***/ }),

/***/ 39044:
/***/ (function(module) {

module.exports = "data:image/png;base64,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"

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6119,1500,481,8861,8127,2722,2392,1171,1156,1877,9071,6999,9774,2888,179], function() { return __webpack_exec__(66015); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);